<template>
  <!-- new design -->
  <div id="booking-widget">
    <div v-if="propertyerror">
      <div class="container">
        <div class="alert alert-danger">
          <strong>Invalid property id {{ propertyid }}.</strong> Please contact
          <a href="mailto:info@reserveport.com">info@reserveport.com.</a>
        </div>
      </div>
    </div>
    <div class="reserveport-form-wrap" v-if="!propertyerror">
      <div class="container vue-content-body">
        <div class="hbf">
          <div class="inner">
            <!-- search bar improved -->
            <h3>
              Check Availability
              <span><small style="font-weight: 200" v-show="spinner">({{ bookingData.name }})</small></span>
            </h3>
            <button type="button" class="edit-search-mobile d-block d-md-none" data-toggle="modal"
              data-target="#modalbookingForm">
              <i class="fa fa-pencil" aria-hidden="true"></i> Edit dates &amp; search
            </button>
            <div class="vue-search-box" v-if="multipropertyStatus == false && clientemail == false">
              <form>

                <div class="row vue-date-box">
                  <div class="col-md-3">
                    <label>Arrival Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckinDate :propertyId="this.property_id"
                        :stayrestrictions="this.bookings.data && this.bookings.data[this.propertyid] ? this.bookings.data[this.propertyid].stay_restrictions : []"
                        @checkin-date-changed="checkAvailabilty">
                      </CheckinDate>
                    </div>
                  </div>

                  <div class="col-md-3 vue-md_p5">
                    <label>Departure Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckoutDate @checkout-date-changed="checkAvailabilty"></CheckoutDate>
                    </div>
                  </div>
                  <div class="col-md-3 vue-md_p5">
                    <label class="guest-link">Occupancy</label>
                    <div class="form-group">
                      <div id="vue-guests-groups" class="vue-small_large_select" style="width: 100%"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="stickMenu">
                        <div id="occupancy-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          <div id="occupancy-text-2" class="pull-left">
                            <span v-if="room > 1">{{ room }} {{ roomLabel.plural }}
                            </span>
                            <span v-else>{{ room }} {{ roomLabel.singular }} |
                              {{ guest }} Guest</span>
                          </div>
                          <div class="pull-right">
                            <img src="https://reservations.reserveport.com/static/img/icon.png" alt="" width="15px" />
                          </div>
                        </div>
                        <div id="vue-dropdown-home" class="dropdown-menu vue-paddt15">
                          <div class="vue-mobile1 pull-left">
                            <div class="row">
                              <div class="col-md-6 col-sm-6 col-6">
                                <label>{{ roomLabel.plural }}</label>
                              </div>
                              <div class="col-md-6 col-sm-6 col-6">
                                <div class="paddb10 block">
                                  <button type="button" v-on:click.prevent="removeRoom" class="vue-btnb"
                                    id="minus-vue-btn-roomsfx">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input disabled="disabled" class="vue-fxcount" :value="room" id="roomsfx"
                                    name="roomsfx" type="text" />
                                  <button type="button" v-on:click.prevent="addRoom" class="vue-btnb"
                                    id="plus-vue-btn-roomsfx">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div id="vue-occupancy-details" v-if="room == 1">
                              <div class="row">
                                <div class="col-md-6 col-6">
                                  <label>Adults</label><small class="vue-ageDiv">({{
                                    ageGroupsDetails.adult_age
                                    }}yr+)</small>
                                </div>
                                <div class="col-md-6 col-6">
                                  <div class="paddb10 block">
                                    <button type="button" v-on:click.prevent="removeAdultCount" class="vue-btnb"
                                      id="minus-vue-btn-adultsfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultAdultNo"
                                      id="occ_adult_l" name="adultsfx" type="text" />
                                    <button type="button" v-on:click.prevent="addAdultCount" class="vue-btnb"
                                      id="plus-vue-btn-adultsfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" style="padding-top: 10px; padding-bottom: 10px"
                                v-if="ageGroupsDetails.children_allowed != 0">
                                <div class="col-md-6 col-6">
                                  <label>Children</label><small class="vue-ageDiv">({{ ageGroupsDetails.child_min_age }}
                                    -
                                    {{
                                    ageGroupsDetails.child_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-6">
                                  <div class="paddb10 block">
                                    <button type="button" v-on:click.prevent="removeChildrenCount" class="vue-btnb"
                                      id="minus-vue-btn-childrenfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" value="0" id="occ_children_l"
                                      name="childrenfx" type="text" />
                                    <button type="button" v-on:click.prevent="addChildrenCount" class="vue-btnb"
                                      id="plus-vue-btn-childrenfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-md-12" v-if="childrenCount > 0">
                                  <div style="display: block" id="ageDiv">
                                    <label id="age_label">Please select the child's age. Children
                                      are considered to be between
                                      {{ ageGroupsDetails.child_min_age }} and
                                      {{
                                      ageGroupsDetails.child_max_age
                                      }}
                                      years.</label>
                                    <div class="child_div" v-for="child in childrenCount" :key="child">
                                      <label>Child {{ child }}</label>
                                      <select id="child_1_age" name="child_1_age" class="child_ages rounded5"
                                        v-on:change="
                                        updateChildAges($event, child)
                                        ">
                                        <option value="">Age</option>
                                        <option v-for="(
                                            childrenagerange, ageindex
                                          ) in computeChildrenAgeRange(
                                            ageGroupsDetails
                                          )" :key="ageindex" :value="childrenagerange.age">
                                          {{ childrenagerange.age }} yrs
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" v-if="ageGroupsDetails.babies_allowed != 0">
                                <div class="col-md-6 col-6">
                                  <label>Infants</label><small class="vue-ageDiv">(0-{{
                                    ageGroupsDetails.baby_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-6">
                                  <div class="paddb10 block">
                                    <button type="button" v-on:click.prevent="removeBabiesCount" class="vue-btnb"
                                      id="minus-vue-btn-babiesfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" value="0" id="occ_babies_l"
                                      name="babiesfx" type="text" />
                                    <button type="button" v-on:click.prevent="addBabiesCount" class="vue-btnb"
                                      id="plus-vue-btn-babiesfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row-fluid" v-if="room > 1">
                              <div class="col-md-12 col-md-12 col-12">
                                <div id="vue-occupancy-details-text" class="hide">
                                  <div class="alert alert-warning mrgb5 paddtb5" role="alert">
                                    Guest occupancy selection in each
                                    {{ roomLabel.singular }} will be availed on
                                    the search results page.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix clear"></div>
                          <div class="col-md-12">
                            <a href="javascript:void(0);" class="pull-right" @click="close"><i class="fa fa-close"></i>
                              Close</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-4 vue-btn-wrap avail-wrap vue-md_p5">
                    <span id="vue-havepromo" class="vue-horizontal" @click="showPromoCode">Add promo code
                    </span>
                    <div id="actPromoCodeact" v-if="showpromo || promo != ''">
                      <input type="text" id="coupon_code_largeScreen" v-model="promo"
                        class="vue-coupon_code_screen vue-horizontal" placeholder="Promo Code" />
                    </div>
                    <!-- </transition> -->
                    <button id="vue-btn-search" v-on:click.prevent="checkAvailabilty()"
                      class="btn btn-md btn-orange-solid">
                      <div v-show="isSearching">
                        <span v-html="searchspinner"></span>
                      </div>
                      <div v-show="!isSearching">Check Availability</div>
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="vue-search-box" v-else>
              <form>
                <div class="row vue-date-box">
                  <div class="col-md-3" v-if="multipropertyStatus == true">
                    <label>Destination</label>
                    <div class="form-group" id="vue-guests-groups">
                      <select class="form-control vue-email_screen sd vue-destination"
                        @click="updateRoomFilter(multiproperties)" v-model="destination">
                        <option :value="initialPropertyId">{{ initialPropertyName }}</option>
                        <option :value="pdestination.id" v-for="(pdestination, destindex) in multiproperties.filter(p => p.id !== initialPropertyId)"
                          :key="destindex">
                          {{ pdestination.propertyName }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <label>Arrival Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckinDate :propertyId="this.property_id"
                        :stayrestrictions="this.bookings.data && this.bookings.data[this.propertyid] ? this.bookings.data[this.propertyid].stay_restrictions : []"
                        @checkin-date-changed="checkAvailabilty">
                      </CheckinDate>
                    </div>
                  </div>

                  <div class="col-md-2 vue-md_p5">
                    <label>Departure Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckoutDate @checkout-date-changed="checkAvailabilty('l')"></CheckoutDate>
                    </div>
                  </div>
                  <div class="col-md-2 vue-md_p5" v-if="multipropertyStatus == true && clientemail == true">
                    <label class="guest-link">Occupancy</label>
                    <div class="form-group">
                      <div id="vue-guests-groups" class="form-control vue-small_large_select" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" @click="stickMenu">
                        <div id="occupancy-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          <div id="occupancy-text-2" class="pull-left">
                            <span v-if="room > 1">{{ room }} {{ roomLabel.plural }}
                            </span>
                            <span v-else>{{ room }} {{ roomLabel.singular }} |
                              {{ guest }} Guest</span>
                          </div>
                          <div class="pull-right">
                            <img src="https://reservations.reserveport.com/static/img/icon.png" alt="" width="15px" />
                          </div>
                        </div>
                        <div id="vue-dropdown-home" class="dropdown-menu vue-paddt15">
                          <div class="vue-mobile1 pull-left">
                            <div class="row">
                              <div class="col-md-6 col-sm-6 col-6">
                                <label>{{ roomLabel.plural }}</label>
                              </div>
                              <div class="col-md-6 col-sm-6 col-6">
                                <div class="paddb10 block">
                                  <button type="button" v-on:click.prevent="removeRoom" class="vue-btnb"
                                    id="minus-vue-btn-roomsfx">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input disabled="disabled" class="vue-fxcount" :value="room" id="roomsfx"
                                    name="roomsfx" type="text" />
                                  <button type="button" v-on:click.prevent="addRoom" class="vue-btnb"
                                    id="plus-vue-btn-roomsfx">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div id="vue-occupancy-details" v-if="room == 1">
                              <div class="row">
                                <div class="col-md-6 col-6">
                                  <label>Adults</label><small class="vue-ageDiv">({{
                                    ageGroupsDetails.adult_age
                                    }}yr+)</small>
                                </div>
                                <div class="col-md-6 col-6">
                                  <div class="paddb10 block">
                                    <button type="button" v-on:click.prevent="removeAdultCount" class="vue-btnb"
                                      id="minus-vue-btn-adultsfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultAdultNo"
                                      id="occ_adult_l" name="adultsfx" type="text" />
                                    <button type="button" v-on:click.prevent="addAdultCount" class="vue-btnb"
                                      id="plus-vue-btn-adultsfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" style="padding-top: 10px; padding-bottom: 10px"
                                v-if="ageGroupsDetails.children_allowed != 0">
                                <div class="col-md-6 col-6">
                                  <label>Children</label><small class="vue-ageDiv">({{ ageGroupsDetails.child_min_age }}
                                    -
                                    {{
                                    ageGroupsDetails.child_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-6">
                                  <div class="paddb10 block">
                                    <button type="button" v-on:click.prevent="removeChildrenCount" class="vue-btnb"
                                      id="minus-vue-btn-childrenfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" value="0" id="occ_children_l"
                                      name="childrenfx" type="text" />
                                    <button type="button" v-on:click.prevent="addChildrenCount" class="vue-btnb"
                                      id="plus-vue-btn-childrenfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-md-12" v-if="childrenCount > 0">
                                  <div style="display: block" id="ageDiv">
                                    <label id="age_label">Please select the child's age. Children
                                      are considered to be between
                                      {{ ageGroupsDetails.child_min_age }} and
                                      {{
                                      ageGroupsDetails.child_max_age
                                      }}
                                      years.</label>
                                    <div class="child_div" v-for="child in childrenCount" :key="child">
                                      <label>Child {{ child }}</label>
                                      <select id="child_1_age" name="child_1_age" class="child_ages rounded5"
                                        v-on:change="
                                        updateChildAges($event, child)
                                        ">
                                        <option value="">Age</option>
                                        <option v-for="(
                                            childrenagerange, ageindex
                                          ) in computeChildrenAgeRange(
                                            ageGroupsDetails
                                          )" :key="ageindex" :value="childrenagerange.age">
                                          {{ childrenagerange.age }} yrs
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" v-if="ageGroupsDetails.babies_allowed != 0">
                                <div class="col-md-6 col-6">
                                  <label>infants</label><small class="vue-ageDiv">(0-{{
                                    ageGroupsDetails.baby_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-6">
                                  <div class="paddb10 block">
                                    <button type="button" v-on:click.prevent="removeBabiesCount" class="vue-btnb"
                                      id="minus-vue-btn-babiesfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" value="0" id="occ_babies_l"
                                      name="babiesfx" type="text" />
                                    <button type="button" v-on:click.prevent="addBabiesCount" class="vue-btnb"
                                      id="plus-vue-btn-babiesfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row-fluid" v-if="room > 1">
                              <div class="col-md-12 col-md-12 col-12">
                                <div id="vue-occupancy-details-text" class="hide">
                                  <div class="alert alert-warning mrgb5 paddtb5" role="alert">
                                    Guest occupancy selection in each
                                    {{ roomLabel.singular }} will be availed on
                                    the search results page.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix clear"></div>
                          <div class="col-md-12">
                            <a href="javascript:void(0);" class="pull-right" @click="close"><i class="fa fa-close"></i>
                              Close</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 vue-md_p5" v-else>
                    <label class="guest-link">Occupancy</label>
                    <div class="form-group">
                      <div id="vue-guests-groups" class="form-control vue-small_large_select" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" @click="stickMenu">
                        <div id="occupancy-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          <div id="occupancy-text-2" class="pull-left">
                            <span v-if="room > 1">{{ room }} {{ roomLabel.plural }}
                            </span>
                            <span v-else>{{ room }} {{ roomLabel.singular }} |
                              {{ guest }} Guest</span>
                          </div>
                          <div class="pull-right">
                            <img src="https://reservations.reserveport.com/static/img/icon.png" alt="" width="15px" />
                          </div>
                        </div>
                        <div id="vue-dropdown-home" class="dropdown-menu vue-paddt15">
                          <div class="vue-mobile1 pull-left">
                            <div class="row">
                              <div class="col-md-6 col-sm-6 col-6">
                                <label>{{ roomLabel.plural }}</label>
                              </div>
                              <div class="col-md-6 col-sm-6 col-6">
                                <div class="paddb10 block">
                                  <button type="button" v-on:click.prevent="removeRoom" class="vue-btnb"
                                    id="minus-vue-btn-roomsfx">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input disabled="disabled" class="vue-fxcount" :value="room" id="roomsfx"
                                    name="roomsfx" type="text" />
                                  <button type="button" v-on:click.prevent="addRoom" class="vue-btnb"
                                    id="plus-vue-btn-roomsfx">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div id="vue-occupancy-details" v-if="room == 1">
                              <div class="row">
                                <div class="col-md-6 col-6">
                                  <label>Adults</label><small class="vue-ageDiv">({{
                                    ageGroupsDetails.adult_age
                                    }}yr+)</small>
                                </div>
                                <div class="col-md-6 col-6">
                                  <div class="paddb10 block">
                                    <button type="button" v-on:click.prevent="removeAdultCount" class="vue-btnb"
                                      id="minus-vue-btn-adultsfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultAdultNo"
                                      id="occ_adult_l" name="adultsfx" type="text" />
                                    <button type="button" v-on:click.prevent="addAdultCount" class="vue-btnb"
                                      id="plus-vue-btn-adultsfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" style="padding-top: 10px; padding-bottom: 10px"
                                v-if="ageGroupsDetails.children_allowed != 0">
                                <div class="col-md-6 col-6">
                                  <label>Children</label><small class="vue-ageDiv">({{ ageGroupsDetails.child_min_age }}
                                    -
                                    {{
                                    ageGroupsDetails.child_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-6">
                                  <div class="paddb10 block">
                                    <button type="button" v-on:click.prevent="removeChildrenCount" class="vue-btnb"
                                      id="minus-vue-btn-childrenfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" value="0" id="occ_children_l"
                                      name="childrenfx" type="text" />
                                    <button type="button" v-on:click.prevent="addChildrenCount" class="vue-btnb"
                                      id="plus-vue-btn-childrenfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-md-12" v-if="childrenCount > 0">
                                  <div style="display: block" id="ageDiv">
                                    <label id="age_label">Please select the child's age. Children
                                      are considered to be between
                                      {{ ageGroupsDetails.child_min_age }} and
                                      {{
                                      ageGroupsDetails.child_max_age
                                      }}
                                      years.</label>
                                    <div class="child_div" v-for="child in childrenCount" :key="child">
                                      <label>Child {{ child }}</label>
                                      <select id="child_1_age" name="child_1_age" class="child_ages rounded5"
                                        v-on:change="
                                        updateChildAges($event, child)
                                        ">
                                        <option value="">Age</option>
                                        <option v-for="(
                                            childrenagerange, ageindex
                                          ) in computeChildrenAgeRange(
                                            ageGroupsDetails
                                          )" :key="ageindex" :value="childrenagerange.age">
                                          {{ childrenagerange.age }} yrs
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" v-if="ageGroupsDetails.babies_allowed != 0">
                                <div class="col-md-6 col-6">
                                  <label>infants</label><small class="vue-ageDiv">(0-{{
                                    ageGroupsDetails.baby_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-6">
                                  <div class="paddb10 block">
                                    <button type="button" v-on:click.prevent="removeBabiesCount" class="vue-btnb"
                                      id="minus-vue-btn-babiesfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" value="0" id="occ_babies_l"
                                      name="babiesfx" type="text" />
                                    <button type="button" v-on:click.prevent="addBabiesCount" class="vue-btnb"
                                      id="plus-vue-btn-babiesfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row-fluid" v-if="room > 1">
                              <div class="col-md-12 col-md-12 col-12 padd-0">
                                <div id="vue-occupancy-details-text" class="hide">
                                  <div class="alert alert-warning mrgb5 paddtb5" role="alert">
                                    Guest occupancy selection in each
                                    {{ roomLabel.singular }} will be availed on
                                    the search results page.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix clear"></div>
                          <div class="col-md-12">
                            <a href="javascript:void(0);" class="pull-right" @click="close"><i class="fa fa-close"></i>
                              Close</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 vue-md_p5" v-if="clientemail">
                    <label id="vue-havepromo">Email</label>
                    <div class="form-group">
                      <input id="coupon_code_largeScreen" class="vue-email_screen" v-model="email" type="email"
                        placeholder="Email address" />
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-4 vue-btn-wrap avail-wrap vue-md_p5"
                    v-if="multipropertyStatus == true && clientemail == true">
                    <span id="vue-havepromo" class="vue-horizontal" @click="showPromoCode">Add promo code
                    </span>
                    <div id="actPromoCodeact" v-if="showpromo || promo != ''">
                      <input type="text" id="coupon_code_largeScreen" v-model="promo"
                        class="vue-coupon_code_screen vue-horizontal" placeholder="Promo Code" />
                    </div>
                    <!-- </transition> -->
                    <button id="vue-btn-search" v-on:click.prevent="checkAvailabilty()"
                      class="btn btn-md btn-orange-solid">
                      <div v-show="isSearching">
                        <span v-html="searchspinner"></span>
                      </div>
                      <div v-show="!isSearching">Check Availability</div>
                    </button>
                  </div>
                  <div class="col-md-2 col-sm-4 vue-btn-wrap avail-wrap vue-md_p5" v-else>
                    <span id="vue-havepromo" class="vue-horizontal" @click="showPromoCode">Add promo code
                    </span>
                    <div id="actPromoCodeact" v-if="showpromo || promo != ''">
                      <input type="text" id="coupon_code_largeScreen" v-model="promo"
                        class="vue-coupon_code_screen vue-horizontal" placeholder="Promo Code" />
                    </div>
                    <!-- </transition> -->
                    <button id="vue-btn-search" v-on:click.prevent="checkAvailabilty('l')"
                      class="btn btn-md btn-orange-solid">
                      <div v-show="isSearching">
                        <span v-html="searchspinner"></span>
                      </div>
                      <div v-show="!isSearching">Check Availability</div>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container vue-content-body" v-if="!propertyerror">
      <!-- search for small devices -->
      <div class="modal" id="modalbookingForm">
        <div class="modal-dialog">
          <div class="modal-header">
            <div class="modal-title">
              <h4>Book Your</h4>
              <h1>{{ roomLabel.plural }}</h1>
            </div>
            <button type="button" id="btn_close" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div id="vue-smallScreen" class="bookingsm hidden-sm hidden-md hidden-lg">

                <div class="row">
                  <div class="col-md-12">
                    <div class="mobilelabel" v-if="multipropertyStatus == true">
                      <label>Destination</label>
                      <select class="form-control vue-small_large_select smallrooms"
                        @click="updateRoomFilter(multiproperties)" v-model="destination">
                        <option :value="initialPropertyId">{{ initialPropertyName }}</option>
                        <option :value="pdestination.id" v-for="(pdestination, destindex) in multiproperties.filter(p => p.id !== initialPropertyId)"
                          :key="destindex">
                          {{ pdestination.propertyName }}
                        </option>
                      </select>
                    </div>
                    <div class="mobilelabel">
                      <span>Arrival Date</span>
                      <CheckinDate :propertyId="this.property_id"
                        :stayrestrictions="this.bookings.data && this.bookings.data[this.propertyid] ? this.bookings.data[this.propertyid].stay_restrictions : []"
                        @checkin-date-changed="checkAvailabilty('s')">
                      </CheckinDate>
                    </div>
                    <div class="mobilelabel">
                      <span>Departure Date</span>
                      <CheckoutDate @checkout-date-changed="checkAvailabilty('s')"></CheckoutDate>
                    </div>
                    <div class="mobilelabel">
                      <span id="checkinlbl">Occupancy</span>
                      <select class="form-control vue-small_large_select smallrooms" v-model="room">
                        <option value="1" selected="selected">1 ROOM</option>
                        <option value="2">2 ROOMS</option>
                        <option value="3">3 ROOMS</option>
                        <option value="4">4 ROOMS</option>
                        <option value="5">5 ROOMS</option>
                        <option value="6">6 ROOMS</option>
                        <option value="7">7 ROOMS</option>
                        <option value="8">8 ROOMS</option>
                        <option value="9">9 ROOMS</option>
                        <option value="10">10 ROOMS</option>
                      </select>
                      <div id="smallcapacity">
                        <select id="occ_adult_s" class="form-control vue-small_large_select" v-model="defaultAdultNo">
                          <option value="1" selected="selected">1 ADULT</option>
                          <option value="2">2 ADULTS</option>
                          <option value="3">3 ADULTS</option>
                          <option value="4">4 ADULTS</option>
                          <option value="5">5 ADULTS</option>
                          <option value="6">6 ADULTS</option>
                          <option value="7">7 ADULTS</option>
                          <option value="8">8 ADULTS</option>
                          <option value="9">9 ADULTS</option>
                          <option value="10">10 ADULTS</option>
                        </select>

                        <select id="occ_children_s" class="form-control vue-small_large_select"
                          v-model="defaultChildrenNo" v-if="ageGroupsDetails.children_allowed != 0">
                          <option value="0" selected="selected">0 CHILDREN</option>
                          <option value="1">1 CHILD</option>
                          <option value="2">2 CHILDREN</option>
                          <option value="3">3 CHILDREN</option>
                          <option value="4">4 CHILDREN</option>
                          <option value="5">5 CHILDREN</option>
                          <option value="6">6 CHILDREN</option>
                          <option value="7">7 CHILDREN</option>
                          <option value="8">8 CHILDREN</option>
                          <option value="9">9 CHILDREN</option>
                          <option value="10">10 CHILDREN</option>
                        </select>
                        <select id="occ_babies_s" class="form-control vue-small_large_select" v-model="defaultbabiesNo"
                          v-if="ageGroupsDetails.babies_allowed != 0">
                          <option value="0" selected="selected">0 BABIES</option>
                          <option value="1">1 BABY</option>
                          <option value="2">2 BABIES</option>
                          <option value="3">3 BABIES</option>
                          <option value="4">4 BABIES</option>
                          <option value="5">5 BABIES</option>
                          <option value="6">6 BABIES</option>
                          <option value="7">7 BABIES</option>
                          <option value="8">8 BABIES</option>
                          <option value="9">9 BABIES</option>
                          <option value="10">10 BABIES</option>
                        </select>
                      </div>
                    </div>
                    <!-- <div class="mobilelabel" v-if="multipropertyStatus == true">
                   <label>Select Room Type</label>
                    <select class="vue-small_large_select smallrooms"  v-model="roomType">
                      <option value="">All</option>
                      <option :value="roomtype.id" v-for="(roomtype, rtypeindex) in filteredRoomTypeArray.roomTypes" :key="rtypeindex">{{roomtype.name}}</option>
                    </select>
                </div> -->
                    <div class="mobilelabel" v-if="clientemail">
                      <span id="emaillbl">Your Email</span>
                      <input id="email_vue-smallScreen" class="vue-email_screen input-clearbg"
                        placeholder="Your email address" type="text" v-model="email" />
                    </div>
                    <div class="mobilelabel">
                      <span class="mobilelabel">Promo Code</span>
                      <input type="text" id="coupon_code_vue-smallScreen" class="form-control coupon_code_screen"
                        placeholder="Promo code" v-model="promo" />
                    </div>

                    <button id="vue-btn-search-mobile" v-on:click.prevent="searchAndCloseMobileModal"
                      @click="scrollToElement" class="btn btn-orange-solid">
                      <div v-show="isSearching">
                        <span v-html="searchspinner"></span>
                      </div>
                      <div v-show="!isSearching">CHECK AVAILABILITY</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- endsearch for small devices -->
      <!-- end search -->
      <div class="row">
        <div class="col-md-12 col-sm-12 col-12" v-if="!residenceTab" v-show="spinner">
          <div class="residencydiv hidden-xs hidden-sm">
            <div class="vue-btn-group pull-left" id="vue-toggle_residency">
              <button type="button" id="btnres" class="res_vue-btn vue-btn-res vue-btn btn active"
                @click.prevent="localResident()">
                Resident
              </button>
              <button type="button" id="btnnonres" class="nonres_vue-btn vue-btn-non-res btn vue-btn"
                @click.prevent="nonResident()">
                Non-Resident
              </button>
            </div>
            <div v-if="bookingData.has_non_refundable_rates" class="d-flex justify-content-end">
              <div class="pull-left">
                <select class="form-control rounded-0" v-model="nonRefundable" @change="checkAvailabilty('l')">
                  <option value="false" selected>Normal Prices</option>
                  <option value="true">Non-Refundable Prices</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" v-if="errormsg !== ''">
          <div class="alert alert-danger" role="alert">
            {{ errormsg }}
          </div>
        </div>
      </div>

      <div class="row mb-4" v-if="guestFormSettings.proof_of_residency_selection == 1 && proof">
        <div class="col-md-12 col-sm-12 col-12">
          <div id="proof">
            <transition name="slide-fade">
              <span class="pull-right">Proof of residency will be required upon check-in.</span>
            </transition>
          </div>
        </div>
      </div>
      <!-- vue-content-body -->
      <div class="row">
        <div class="col-md-9 col-sm-12 col-12">
          <div class="row">
            <div class="act-overlay" v-show="!spinner">
              <loader-terms></loader-terms>
            </div>
          </div>
          <div class="vue-card-unit" v-for="(booking, bindex) in bookingData.rooms" :key="bindex" v-show="spinner">
            <div class="vue-card-unit-title">
              <span class="room-title"
                @click="gotoRoomDetail(booking.id, booking.availability.available, booking.availability.allowOnlineBookings == 1, booking)"
                style="cursor: pointer">{{ booking.name }}
              </span><span style="color: #bd362f" v-if="booking.availability.available == 0">(SOLD OUT)</span>
              <span v-if="booking.lastBooked !== ''" class="availability_text">{{ booking.lastBooked }}</span>
            </div>
            <div>
              <div class="row">
                <div class="col-md-4 col-sm-12 col-12">
                  <div class="room-thumb" v-if="booking.images && booking.images.length">
                    <div class="room-thumb-track"
                      :style="{ transform: 'translateX(-' + ((roomImageIndex[bindex] || 0) * 100) + '%)' }">
                      <img v-for="(img, imgIndex) in booking.images" :key="imgIndex" :src="img" :alt="booking.name"
                        class="room-thumb-img" />
                    </div>
                    <template v-if="booking.images.length > 1">
                      <button type="button" class="room-thumb-nav room-thumb-nav-prev"
                        @click.prevent="changeRoomImage(bindex, booking.images.length, -1)" aria-label="Previous image">
                        <i class="fa fa-angle-left"></i>
                      </button>
                      <button type="button" class="room-thumb-nav room-thumb-nav-next"
                        @click.prevent="changeRoomImage(bindex, booking.images.length, 1)" aria-label="Next image">
                        <i class="fa fa-angle-right"></i>
                      </button>
                      <span class="room-thumb-counter">{{ (roomImageIndex[bindex] || 0) + 1 }}/{{ booking.images.length }}</span>
                    </template>
                  </div>
                  <div class="room-thumb" v-else>
                    <img src="https://reservations.reserveport.com/offers/static/img/noimages.jpg" :alt="booking.name"
                      class="room-thumb-img" />
                  </div>
                </div>
                <!--  -->
                <div class="col-md-8 col-sm-12 col-12">
                  <div v-if="booking.availability.allowOnlineBookings == 1">
                    <div v-for="(board, index) of booking.boards" :key="index" class="vue-pad-content">
                      <div v-if="(bookingData.currency.res != '' &&
                        board.roomPrice.res != 0) ||
                        (bookingData.currency.nonres != '' &&
                          board.roomPrice.nonres != 0)
                        ">
                        <div class="vue-border-btm padtb-1rem">
                          <div class="row">
                            <div class="col-md-5 col-sm-3 col-5 col-5">
                              <span class="text-center-sm text-center-xs">
                                <i class="fa fa-check"></i>
                                <strong> {{ board.name }}</strong>
                              </span>
                              <div>
                                <i class="small">{{ board.description }}</i>
                              </div>
                            </div>
                            <div class="col-md-4 col-sm-3 col-12 col-7" id="priceDetail"
                              v-if="booking.availability.available !== 0">
                              <!-- resident -->
                              <span class="small">Starting from</span>
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{
                                        bookingData.currency.nonres
                                        }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small"><strong>for {{ period }} {{ periodText }}</strong></span><br />
                              <span class="small">{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                            <div class="col-md-3 col-sm-3 col-12" v-if="booking.availability.available !== 0">
                              <div class="vue-mobile-nonvue-mobile">
                                <label class="unit-label"><strong>{{
                                    roomLabel.singular
                                    }}</strong></label>
                              </div>
                              <div class="booking-btngrp input-prepend">
                                <button type="button" class="vue-btnbb" :id="'unit-selection-minus-vue-btn-' +
                                    booking.id +
                                    '-' +
                                    index
                                    " v-on:click="
      deleteDiv(board, index, booking.id)
      ">
                                  <i class="fa fa-minus"></i>
                                </button>
                                <input type="text" class="vue-fcount" disabled="disabled" value="0" :id="'unit-selection-' + booking.id + '-' + index
                                  " />
                                <button type="button" class="vue-btnbb" :id="'unit-selection-plus-vue-btn-' +
                                  booking.id +
                                  '-' +
                                  index
                                  " v-on:click="
    createDiv(board, index, booking.id, booking)
    ">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                            </div>
                            <!-- show price instead of button if room non available -->
                            <div class="col-md-7 col-sm-3 col-12" id="priceDetail"
                              v-if="booking.availability.available == 0">
                              <!-- resident -->
                              <span class="small">Starting from</span>
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{
                                        bookingData.currency.nonres
                                        }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small"><strong>for {{ period }} {{ periodText }}</strong></span><br />
                              <span class="small">{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- multple room  -->
                      <div class="vue-loading-cover" :id="'loading-cover-' + booking.id + '-' + index">
                        <div v-for="(n, indx) in divs.filter(
                          (x) => x.key == index && x.roomid == booking.id
                        )" :key="indx" class="row roomborder-btm mobile-padd padtb-1rem">
                          <div class="col-md-2 col-sm-2 col-12">
                            <label class="uppercase room_no">{{ roomLabel.singular }} &nbsp;<span>{{
                                indx + 1
                                }}</span></label>
                          </div>
                          <div class="col-md-10 col-sm-10 unit-config col-12">
                            <div class="row">
                              <div class="col-6 col-md-6"></div>
                              <div class="col-4 col-md-4"></div>
                              <div class="col-2 col-md-2">
                                <div class="vue-mobile-nonvue-mobile">
                                  <!--<i
                                  class="fa fa-remove"
                                  style="color: red"
                                  v-on:click="removeItem(indx, board, n, booking,index)"
                                ></i>-->
                                  <div class="close-container" v-on:click="
                                  removeItem(indx, board, n, booking, index)
                                    ">
                                    <div class="leftright"></div>
                                    <div class="rightleft"></div>
                                    <label class="close">close</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-4 col-sm-4 col-4 col-4">
                                <div class="vue-mobile-nonvue-mobile">
                                  <label class="unit-label">adults</label>
                                  <small>
                                    ({{ ageGroupsDetails.adult_age }}yr+)</small>
                                </div>
                                <div class="booking-btngrp input-prepend">
                                  <button type="button" class="vue-btnbb" v-on:click="
                                    removeAdult(
                                      indx,
                                      booking,
                                      board,
                                      n,
                                      index
                                    )
                                    " :disabled="clicked">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input type="text" :id="'adult-' + n.ukey" class="vue-fcount" size="2"
                                    disabled="disabled" :value="n.adult" />
                                  <button type="button" class="vue-btnbb" v-on:click="
                                    addAdult(indx, booking, board, n, index)
                                    " :disabled="clicked">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                              <div class="col-md-4 col-sm-4 col-4 col-4"
                                v-if="ageGroupsDetails.children_allowed != 0">
                                <div class="vue-mobile-nonvue-mobile">
                                  <label class="unit-label">children</label>
                                  <small>
                                    ({{ ageGroupsDetails.child_min_age }} -
                                    {{
                                    ageGroupsDetails.child_max_age
                                    }}yr)</small>
                                </div>
                                <div class="booking-btngrp input-prepend">
                                  <button type="button" class="vue-btnbb" v-on:click="
                                  removeChild(
                                    indx,
                                    booking,
                                    board,
                                    n,
                                    index
                                  )
                                    ">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input type="text" class="vue-fcount" size="2" :id="'children-' + n.ukey"
                                    disabled="disabled" :value="n.children" />
                                  <button type="button" class="vue-btnbb" v-on:click="addChild(n, booking)">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                              <div class="col-md-4 col-sm-4 col-4 col-4" v-if="ageGroupsDetails.babies_allowed != 0">
                                <div class="vue-mobile-nonvue-mobile">
                                  <label class="unit-label">infants</label>
                                  <small>
                                    (0-{{
                                    ageGroupsDetails.baby_max_age
                                    }}yr)</small>
                                </div>
                                <div class="booking-btngrp input-prepend">
                                  <button type="button" class="vue-btnbb" v-on:click="
                                  removeInfant(
                                    indx,
                                    booking,
                                    board.name,
                                    n,
                                    index
                                  )
                                    ">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input type="text" class="vue-fcount" size="2" disabled="disabled"
                                    :value="n.infant" />
                                  <button type="button" class="vue-btnbb set_count_plus"
                                    id="unit-selection-plus-vue-btn-416-1" v-on:click="
                                      addInfant(indx, booking, board, n, index)
                                      ">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->

                          <div class="col-md-12" v-if="n.children > 0">
                            <div id="age-div-399-3-0" class="vue-ageDivMultiple" style="display: block">
                              <label class="age_notice">Please select the age of each child. Children
                                are considered to be between {{ ageGroupsDetails.child_min_age }} and
                                {{ ageGroupsDetails.child_max_age }}
                                years.</label>
                              <div class="child_div" v-for="(child, chindex) in n.children" :key="chindex">
                                <label class="child_number">child {{ chindex + 1 }}</label>
                                <select id="child_399_0_board_3_1_age" name="child_399_0_board_3_1_age"
                                  class="form-control" v-on:change="
                                    updateChildren(
                                      $event,
                                      booking,
                                      indx,
                                      board,
                                      n,
                                      index,
                                      chindex
                                    )
                                    ">
                                  <option value="0">Age</option>
                                  <option v-for="(
                                      childrenagerange, ageindex
                                    ) in computeChildrenAgeRange(
                                      ageGroupsDetails
                                    )" :key="ageindex" :value="childrenagerange.age">
                                    {{ childrenagerange.age }} yrs
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <span class="vue-loading" :id="'loading-' + booking.id + '-' + index" style="display: none">
                          <!-- <i class="fa fa-circle-o-notch fa-spin" style="font-size:24px"></i><br>loading ... -->
                          <i class="fa fa-spinner fa-spin" id="spinnerl" style="font-size: 24px; color: #ff6600"></i>
                        </span>
                      </div>
                      <!-- end -->
                    </div>
                  </div>
                  <div v-else class="vue-pad-content">
                    <div class="alert alert-warning mrgtb20 paddtb10" role="alert"
                      v-if="booking.availability.available !== 0">
                      <span class="fa fa-bell-o faa-ring animated"></span>
                      Please send an email
                      to
                      <a :href="bookingData.contactDetails.mainEmail">{{
                        bookingData.contactDetails.mainEmail
                        }}</a>
                      to reserve this room.
                    </div>
                    <div v-for="(board, index) of booking.boards" :key="index" class="vue-pad-content"
                      v-if="booking.availability.available !== 0 && booking.availability.allowOnlineBookings == 2">
                      <div v-if="(bookingData.currency.res != '' &&
                              board.roomPrice.res != 0) ||
                            (bookingData.currency.nonres != '' &&
                              board.roomPrice.nonres != 0)
                            ">
                        <div class="vue-border-btm padtb-1rem">
                          <div class="row">
                            <div class="col-md-5 col-sm-3 col-5 col-5">
                              <span class="text-center-sm text-center-xs">
                                <i class="fa fa-check"></i>
                                <strong> {{ board.name }}</strong>
                              </span>
                              <div>
                                <i class="small">{{ board.description }}</i>
                              </div>
                            </div>
                            <div class="col-md-4 col-sm-3 col-12 col-7" id="priceDetail"
                              v-if="booking.availability.available !== 0">
                              <!-- resident -->
                              <span class="small">Starting from</span>
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{
                                        bookingData.currency.nonres
                                        }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small"><strong>for {{ period }} {{ periodText }}</strong></span><br />
                              <span class="small">{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                            <!-- show price instead of button if room non available -->
                            <div class="col-md-7 col-sm-3 col-12" id="priceDetail"
                              v-if="booking.availability.available == 0">
                              <!-- resident -->
                              <span class="small">Starting from</span>
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{
                                        bookingData.currency.nonres
                                        }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small"><strong>for {{ period }} {{ periodText }}</strong></span><br />
                              <span class="small">{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- multple room  -->
                      <div class="vue-loading-cover" :id="'loading-cover-' + booking.id + '-' + index">
                        <div v-for="(n, indx) in divs.filter(
                            (x) => x.key == index && x.roomid == booking.id
                          )" :key="indx" class="row roomborder-btm mobile-padd padtb-1rem">
                        </div>
                      </div>
                      <!-- end -->
                    </div>
                  </div>
                  <!-- added div -->
                  <div class="vue-card-unit-summary">
                    <div class="row">
                      <div class="col-md-12">
                        <ul class="mrg0">
                          <li class="mrgb10" v-if="booking.availability.available == 0">
                            <div class="soldoutdates">
                              <label class="soldout-lbl">Sold Out on</label>
                              <div v-for="(soldoutdate, soldindex) in booking
                                    .availability.soldOutDates" :key="soldindex" style="display: inline">
                                <span class="soldoutspan">{{
                                  soldoutdate
                                  }}</span>
                              </div>
                            </div>
                          </li>
                          <li class="mrgb10" v-if="Object.keys(booking.discount_coupons).length !== 0
                            ">
                            <div class="row specialoffer">
                              <div class="col-md-12" v-for="(
                                  bdiscount, bindex
                                ) in booking.discount_coupons" :key="bindex">
                                <i class="fa fa-tag"></i><span> {{ bdiscount.code }}</span><br />
                                <small><strong>Applicable Boards:</strong>
                                  <span>{{ bdiscount.boards }}</span> </small><br /><small>
                                  <strong>Coupon Code: </strong>
                                  {{ bdiscount.code }}</small><br /><small>
                                  <strong>Applicable dates: </strong>
                                  {{ bdiscount.start_date }} To
                                  {{ bdiscount.end_date }}</small><br /><small>
                                  <strong>Promo Type: </strong>
                                  {{ bdiscount.type }}</small>
                              </div>
                            </div>
                          </li>
                          <li class="mrgb10">
                            <div class="row availablityroomdetail" v-if="booking.availability.allowOnlineBookings == 1
                              ">
                              <div class="col-md-12">
                                <div v-if="booking.availability.available <=
                                  booking.availability.alertLimit &&
                                  booking.availability.available !== 0
                                  ">
                                  <span style="color: #cc0000"><span v-if="booking.availability.available > 1">{{
                                      booking.availability.available
                                      }}
                                      {{ roomLabel.plural }}</span>
                                    <span v-else>
                                      Only {{ booking.availability.available }}
                                      {{ roomLabel.singular }}</span>
                                    like this left in our property</span>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li class="mrgb10">
                            <span><b>Number of adults</b></span>: {{ booking.occupancy.maximumAdultOccupancy }} Max
                          </li>

                          <li class="mrgb10">
                            <span v-if="ageGroupsDetails.babies_allowed != 0"><strong>Infants: </strong>below
                              {{ ageGroupsDetails.baby_max_age }} years |
                            </span>
                            <span v-if="ageGroupsDetails.children_allowed != 0"><strong>Children: </strong>{{
                              ageGroupsDetails.child_min_age
                              }} -
                              {{ ageGroupsDetails.child_max_age }} years |
                            </span>
                            <strong>Adult: </strong>
                            {{ ageGroupsDetails.adult_age }} years and above
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="clear clearfix"></div>
                  <div class="vue-card-unit-footer">
                    <div class="row">
                      <div class="col-md-12">
                        <span class="uppercase vue-show-details" id="vue-show-details-1410"
                          v-if="booking.description !== ''" @click="rdetail(booking.id)">{{ roomLabel.singular }}
                          details</span>
                        <span class="sep" v-if="bookingData.description !== '' && bookingData.terms !== ''">|</span>
                        <span id="vue-show-tc-1410" href="#" class="uppercase vue-show-tc"
                          v-if="bookingData.terms !== ''" @click="termCondition(booking.id)">Terms and conditions</span>
                        <span class="sep"
                          v-if="bookingData.cancellation_policies !== '' && bookingData.terms !== '' || bookingData.description !== '' && bookingData.terms !== ''">|</span>
                        <span id="vue-show-tc-1410" href="#" class="uppercase vue-show-tc"
                          v-if="bookingData.cancellation_policies !== ''" @click="cancPolicy(booking.id)">Cancellation
                          policies</span>
                      </div>
                    </div>
                  </div>
                  <!-- modal for proof of residency pop -->
                  <div class="modal" id="proffmodalpopup">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <!-- Modal body -->
                        <div class="proof_modal_body">
                          Dear Guest, <br /><br />
                          <p>
                            Please note that you have selected resident rates
                          </p>
                          <p>
                            As per company policies proof of residency will be
                            required upon check-in
                          </p>
                          <div class="proof_modal_list">
                            <ul>
                              <li>
                                If you do confirm that you are a resident kindly
                                click 'OK' to proceed with your booking
                              </li>
                              <li>
                                If you are a non-resident, kindly click 'CANCEL'
                                and use the resident/non-resident tabs to switch
                                to the non-resident portal
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <div class="btn-toolbar pull-right" role="toolbar" aria-label="Toolbar with button groups">
                            <div class="btn-group mr-2" role="group" aria-label="Second group">
                              <button type="button" id="vue-btn" class="btn btn-outline" data-dismiss="modal">
                                Cancel
                              </button>
                            </div>
                            <div class="btn-group" role="group" aria-label="Third group">
                              <button type="button" class="btn btn-solid" id="vue-btn" @click.prevent="
                                redirectToMultiroomBookDetail(
                                  bookingDataProof,
                                  boardDataProof
                                )
                                " data-dismiss="modal">
                                OK
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end -->
                </div>
                <!--  -->
              </div>
            </div>
            <!--child-->
            <div class="row">
              <div class="col-md-12 col-sm-12 col-12">
                <transition name="slide-fade">
                  <div class="vue-card-unit-description" v-if="descr == booking.id">
                    <span class="uppercase"><strong>{{ roomLabel.singular }} Details</strong></span>
                    <div v-html="booking.description"></div>
                    <ul class="vue-features-list">
                      <li class="feat vue-non-icons" v-for="(feature, index) in booking.features" :key="index">
                        <i class="fa fa-check"></i> {{ feature.name }}
                      </li>
                    </ul>
                  </div>
                  <div class="vue-card-unit-description" v-if="term == booking.id">
                    <span class="uppercase"><strong>Terms and conditions</strong></span>
                    <div v-html="bookingData.terms"></div>
                  </div>
                  <div class="vue-card-unit-description" v-if="canc == booking.id">
                    <span class="uppercase"><strong> Cancellation Policies</strong></span>
                    <div v-html="bookingData.cancellation_policies"></div>
                  </div>
                </transition>
              </div>
            </div>
            <!-- break is here -->
          </div>
        </div>

        <div class="col-md-3 col-sm-12 col-12" v-show="spinner">
          <div class="vue-right-side">
            <div class="row">
              <div class="col-md-12">
                <div class="vue-side_top_card">
                  <h3>
                    {{ bookingData.name }}
                  </h3>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="vue-side_bottom_card">
                  <h3>SUMMARY</h3>
                  <div class="row" v-if="multiRoomResult && Object.keys(multiRoomResult).length !== 0">
                    <div class="col-md-2">
                      <img id="bedimg" :src="'https://reservations.reserveport.com/static/img/logo.png'" width="56" />
                      <!-- <i class="fa fa-bed " style="font-size:38px;color:#007800"></i> -->
                    </div>
                    <div class="header-content col-md-10 ol-sm-12 col-12" style="text-align: left !important">
                      <span><strong>Adult:</strong> {{ totalAdultCount }} <br /></span>
                      <span v-if="totalChildrenCount > 0"><strong>Children:</strong> {{ totalChildrenCount }}
                        <br /></span>
                      <span><strong>Check-in:</strong>&nbsp;{{ checkinDate }} <br /></span>
                      <span><strong>Check-out:</strong>&nbsp;{{ checkoutDate }}
                        <br /></span>
                    </div>
                  </div>
                  <div class="row" v-if="Object.keys(multiRoomResult).length !== 0">
                    <div class="col-md-12">
                      <div>
                        <table id="room_details_1" class="table table-small-font table-responsive mrgb5">
                          <thead>
                            <tr>
                              <th width="10%" style="text-align: left">
                                {{ roomLabel.singular }} details
                              </th>
                              <th width="10%" style="text-align: right">
                                Total
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(mroom, index) in multiRoomResult" :key="index">
                              <td width="10%" class="prclabel">
                                {{ mroom.room.name }}
                              </td>
                              <td v-if="proofRes === 0" width="10%" valign="middle" style="text-align: right">
                                {{ bookingData.currency.res }}
                                {{ formatPrice(mroom.data.roomPrice.res) }}
                              </td>
                              <td v-if="proofRes === 1" width="10%" valign="middle" style="text-align: right">
                                {{ bookingData.currency.nonres }} &nbsp;
                                {{ formatPrice(mroom.data.roomPrice.nonres) }}
                              </td>
                            </tr>
                            <!--  -->
                            <tr v-if="totalDiscount.res > 0 ||
                              totalDiscount.nonres > 0
                              ">
                              <td width="10%" class="prclabel">
                                <b> Discount</b>
                              </td>
                              <td>
                                <div v-if="proofRes === 0">
                                  <span>{{ bookingData.currency.res }}</span>
                                  {{ formatPrice(totalDiscount.res) }}
                                </div>
                                <div v-if="proofRes === 1">
                                  <span>{{ bookingData.currency.nonres }}</span>
                                  {{ formatPrice(totalDiscount.res) }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div>
                        <table class="table table-small-font table-responsive mrgb5">
                          <tbody>
                            <tr v-if="serviceCharge.nonres > 0 ||
                              serviceCharge.res > 0
                              ">
                              <td width="10%" class="prclabel">
                                <b> SERVICE CHARGES</b> &nbsp;
                                <span class="tool-tip" v-if="bookingData.extra_charges.service_charge
                                  .is_percentage_based == 1
                                  ">
                                  <i class="fa fa-info-circle" @mouseover="servicechrg = true"
                                    @mouseleave="servicechrg = false"></i>
                                </span>
                                <div class="tax-tooltip" v-show="servicechrg">
                                  <i class="fa fa-info"></i>
                                  <span class="tooltip-header">Service Charge</span><br />
                                  <p v-if="proofRes == 0">
                                    {{
                                    bookingData.extra_charges.service_charge
                                    .value.res
                                    }}% service charge
                                  </p>
                                  <p v-if="proofRes == 1">
                                    {{
                                    bookingData.extra_charges.service_charge
                                    .value.nonres
                                    }}% service charge
                                  </p>
                                </div>
                              </td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes === 0">
                                  <span>{{ bookingData.currency.res }}</span>
                                  <span>{{
                                    formatPrice(serviceCharge.res)
                                    }}</span>
                                </div>
                                <div v-if="proofRes === 1">
                                  <span>{{ bookingData.currency.nonres }}</span>
                                  <span>{{
                                    formatPrice(serviceCharge.nonres)
                                    }}</span>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="totalVat.nonres > 0 || totalVat.res > 0">
                              <td width="10%" class="prclabel">
                                <b> TOTAL VAT:</b>
                                <span class="tool-tip">
                                  <i class="fa fa-info-circle" @mouseover="taxhover = true"
                                    @mouseleave="taxhover = false"></i>
                                </span>
                                <div class="tax-tooltip" v-show="taxhover">
                                  <i class="fa fa-info"></i>
                                  <span class="tooltip-header">Total VAT</span><br />
                                  <p>
                                    {{ bookingData.vat.value }}% on
                                    {{ roomLabel.plural }}, service charges &
                                    enhancements
                                  </p>
                                </div>
                              </td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes === 0">
                                  <span>{{ bookingData.currency.res }}</span>
                                  <span>{{ formatPrice(totalVat.res) }}</span>
                                </div>
                                <div v-if="proofRes === 1">
                                  <span>{{ bookingData.currency.nonres }}</span>
                                  <span>{{
                                    formatPrice(totalVat.nonres)
                                    }}</span>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="hotelTax.nonres > 0 || hotelTax.res > 0">
                              <td width="10%" class="prclabel">
                                <b>{{
                                  bookingData.extra_charges.hotel_tax.name
                                  }}:</b>
                              </td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes === 0">
                                  <span>{{ bookingData.currency.res }}</span>
                                  <span>{{ formatPrice(hotelTax.res) }}</span>
                                </div>
                                <div v-if="proofRes === 1">
                                  <span>{{ bookingData.currency.nonres }}</span>
                                  <span>{{
                                    formatPrice(hotelTax.nonres)
                                    }}</span>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="bookingData.extra_charges.gateway_fee_enabled ==
                                1 && totalGatewayFee.res > 0
                                ">
                              <td width="10%" class="prclabel">
                                <b>Total Gateway Fee:</b>
                              </td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes === 0">
                                  <span>{{ bookingData.currency.res }}</span>
                                  <span>{{
                                    formatPrice(totalGatewayFee.res)
                                    }}</span>
                                </div>
                                <div v-if="proofRes === 1">
                                  <span>{{ bookingData.currency.nonres }}</span>
                                  <span>{{
                                    formatPrice(totalGatewayFee.nonres)
                                    }}</span>
                                </div>
                              </td>
                            </tr>
                            <tr class="pricetotal">
                              <td width="10%" class="prclabel">
                                <b>Total:</b>
                              </td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes === 0">
                                  <span>{{ bookingData.currency.res }}</span>
                                  <span>{{ formatPrice(total.res) }}</span>
                                </div>
                                <div v-if="proofRes === 1">
                                  <span>{{ bookingData.currency.nonres }}</span>
                                  <span>{{ formatPrice(total.nonres) }}</span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-if="guestFormSettings.proof_of_residency_popup == 0">
                        <input style="cursor: pointer" type="button" id="summery-submit"
                          class="btn vue-btn-vue-block vue-btn-proceed" value="Continue" @click.prevent="
                            redirectToMultiroomBookDetail(
                              multiRoomResult,
                              selectedRooms
                            )
                            " :disabled="clicked" />
                      </div>
                      <div v-if="guestFormSettings.proof_of_residency_popup == 1">
                        <input style="cursor: pointer" type="button" data-toggle="modal" data-target="#proffmodalpopup"
                          id="summery-submit" class="btn vue-btn-vue-block vue-btn-proceed" value="Continue"
                          v-if="resident == 'resident'" @click="
                            openProofModal(multiRoomResult, selectedRooms)
                            " :disabled="clicked" />
                        <input style="cursor: pointer" type="button" data-toggle="modal" id="summery-submit"
                          class="btn vue-btn-vue-block vue-btn-proceed" value="Continue"
                          v-if="resident == 'non-resident'" @click.prevent="
                            redirectToMultiroomBookDetail(
                              multiRoomResult,
                              selectedRooms
                            )
                            " :disabled="clicked" />
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div id="no_room_selected" class="no-roomdiv vue-block">
                      <img id="no_room_selected_img" :src="'https://reservations.reserveport.com/static/img/bed.png'"
                        width="90" />
                      <h4 id="no-rooms">
                        No {{ roomLabel.singular }}(s) Selected
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="paginatedData.length > 0 &&
              Object.keys(multiRoomResult).length == 0
              " v-show="bookingData.show_coupon_ads == 1">
              <div class="col-md-12">
                <div class="vue-offers-card">
                  <div class="vue-card" v-for="(soffer, sindex) in paginatedData" :key="sindex">
                    <img class="card-img-top vue-responsive" style="cursor: pointer" @click="submitOffer"
                      v-if="soffer.image !== ''" :src="soffer.image" alt="Card image" />
                    <img class="card-img-top vue-responsive" style="cursor: pointer" @click="submitOffer" v-else
                      src="https://reservations.reserveport.com/offers/static/img/noimages.jpg" alt="Card image" />
                    <div class="vue-offers-card-body">
                      <h4 class="card-title" style="cursor: pointer" @click="submitOffer">
                        {{ soffer.couponCode }}
                      </h4>
                      <div v-if="soffer.type == 'rateoveride'">
                        <small class="startingfrom">Price starts from </small>
                        <div v-if="soffer.currencyRes != 0 && soffer.currencyRes != ''
                          " class="rates">
                          <span v-if="soffer.adultRate.res > 0"><strong>{{ soffer.currencyRes }}
                              {{ soffer.adultRate.res }}</strong></span>
                          <span v-else><strong>{{ soffer.currencyRes }}
                              {{ soffer.childRate.res }}</strong></span>
                        </div>
                        <div v-else>
                          <span v-if="soffer.adultRate.nonres > 0"><strong>{{ soffer.currencyNonRes }}
                              {{ soffer.adultRate.nonres }}</strong></span>
                          <span v-else><strong>{{ soffer.currencyNonRes }}
                              {{ soffer.childRate.nonres }}</strong></span>
                        </div>
                      </div>
                      <div v-if="soffer.type == 'discount_percentage'">
                        <small class="startingfrom">Discount </small>
                        <span><strong>{{ soffer.discountRes }} %</strong></span>
                      </div>
                      <div v-if="soffer.type == 'discount_flatrate'">
                        <small class="startingfrom">Discount </small>
                        <div v-if="soffer.currencyRes != 0 && soffer.currencyRes != ''
                          " class="rates">
                          <span><strong>{{ soffer.currencyRes }}
                              {{ soffer.discountRes }}</strong></span>
                        </div>
                        <div v-else class="rates">
                          <span><strong>{{ soffer.currencyNonRes }}
                              {{ soffer.discountNonRes }}</strong></span>
                        </div>
                      </div>
                      <div></div>
                      <br />
                      <!-- <small>{{soffer.propertyName}}</small> -->
                      <!-- <h5>September 18-20, 2017</h5> -->
                      <!-- <p class="card-text" v-html="soffer.introText"></p> -->
                      <form :action="soffer.embedLink" method="get" id="vueofferForm">
                        <input type="hidden" name="pid" :value="soffer.propertyId" />
                        <input type="hidden" name="checkin_date" :value="getCheckinDate(soffer.startDate)" />
                        <input type="hidden" name="checkout_date" :value="getCheckoutDate(soffer.startDate, soffer.minNights)
                          " />
                        <input type="hidden" name="adults" value="1" />
                        <input type="hidden" :value="soffer.couponCode" name="coupon_code" />
                        <button type="submit" class="btn btn-orange-solid" style="margin-top: auto">
                          Book Now
                        </button>
                      </form>
                    </div>
                  </div>
                  <div class="section-content" v-if="pageCount > 1" style="text-align: right">
                    <span @click="prevPage" style="margin-right: 15px; cursor: pointer"><i
                        class="fa fa-angle-left"></i></span>
                    <span>{{ currentPage }} / {{ pageCount }}</span>
                    <span @click="nextPage" style="margin-left: 15px; cursor: pointer"><i
                        class="fa fa-angle-right"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end -->
    </div>
    <div class="mobile_booking_wrapper">
      <button class="mobile_booking_dates" id="mobile_booking_dates_triger" data-toggle="modal"
        data-target="#modalbookingForm">
        <i class="fa fa-calendar-o mobile_booking_dates_icon" aria-hidden="true"></i>
        <span class="mobile_booking_date_segment">
          <span class="mobile_booking_date_label">Check-in</span>
          <span class="mobile_booking_date_value">{{ mobileCheckinLabel }}</span>
        </span>
        <span class="mobile_booking_date_divider"></span>
        <span class="mobile_booking_date_segment">
          <span class="mobile_booking_date_label">Check-out</span>
          <span class="mobile_booking_date_value">{{ mobileCheckoutLabel }}</span>
        </span>
      </button>
      <button class="btn btn-orange-solid" id="mobile_booking_triger" type="button" v-show="!hideMobileContinueBar" @click.prevent="scrollToSelection">
        Continue </button>
    </div>
  </div>
  <!-- end new design -->
</template>

<script>
import loader from '../components/loader.vue'
import reusableData from '../components/mixins/reusableData'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import CheckinDate from './dates/checkinDate.vue'
import CheckoutDate from './dates/checkoutDate.vue'
import 'vue2-datepicker/index.css'
import { mapState } from 'vuex'

export default {
  name: 'Booking',
  props: ['data'],
  components: {
    'loader-terms': loader,
    CheckinDate, CheckoutDate
  },
  data () {
    return {
      errors: false,
      errorMsg: [],
      residenceTab: false,
      propertyerror: false,
      bookingDataProof: '',
      boardDataProof: '',
      selectedBoard: [],
      roomSummary: {},
      errormsg: '',
      selectedRooms: {},
      canc: null,
      checkdate: '',
      checkoutdate1: '',
      resident: this.$store.state.residency,
      componentKey: 0,
      propertyid: '',
      childAges: [],
      isSearching: false,
      searchspinner: "<i class='fa fa-spinner fa-spin '></i> SEARCHING",
      servicechrg: false,
      spinner: false,
      taxhover: false,
      clicked: false,
      displayDiv: null,
      divs: [],
      count: 0,
      promoCode: false,
      period: '',
      periodText: 'night',
      checkOutDate: '',
      board_room_price: 0,
      bookings: [],
      descr: null,
      term: null,
      proof: false,
      proofRes: this.$store.state.proofRes,
      guestOccupancy: '',
      url: null,
      roomPrice: 0,
      totalRoomPrice: 0,
      subTotal: 0,
      totalGatewayFee: 0,
      roomDiscount: 0,
      totalDiscount: 0,
      total: 0,
      serviceCharge: 0,
      totalVat: 0,
      hotelTax: 0,
      destination: '',
      occupancy: '',
      email: '',
      promo: '',
      guest: 1,
      children: 0,
      multiRoomResult: {},
      resultData: [],
      babies: 0,
      infant: 0,
      child: 0,
      adultCount: 0,
      roomId: '',
      mealPlan: '',
      adult: 1,
      defaultAdultNo: 1,
      defaultChildrenNo: 0,
      defaultbabiesNo: 0,
      room: 1,
      children_ages: [],
      multi_result: false,
      totalAdults: 0,
      totalChildren: 0,
      totalBabies: 0,
      roomType: '',
      totalAdultCount: 0,
      totalChildrenCount: 0,
      totalBabiesCount: 0,
      roomImageIndex: {},
      consumerKey: '',
      multipropertyStatus: false,
      updatedPrices: {},
      roomTypes: '',
      multiproperties: [],
      filteredRoomTypeArray: '',
      clientemail: false,
      ageGroupsDetails: '',
      bookingData: '',
      guestFormSettings: '',
      roomData: '',
      availableRates: true,
      offers: [],
      currentPage: 1,
      size: 1,
      computedChildAges: [],
      showpromo: false,
      roomLabel: '',
      chckinDate: '',
      chckoutDate: '',
      childrenCount: 0,
      secretKey: '',
      postUrl: '',
      ppKey: '',
      ppSecret: '',
      dateChanged: false,
      nonRefundable: false,
      hideMobileContinueBar: true
    }
  },
  created () {
    if (this.$root.occupancy !== undefined) {
      if (this.$root.occupancy !== '') {
        this.adult = parseInt(this.$root.occupancy)
        this.defaultAdultNo = parseInt(this.$root.occupancy)
      }
    }
    var hash = document.location.hash
    var urlparameters = hash.split('?')[1]
    var propid = urlparameters.split('&')[0]
    // var reference =
    var encodedpid = propid.split('=')[1]
    var reconstructedpid1 = encodedpid.split('%3D')
    var reconstructedpid = reconstructedpid1.join('=')
    this.propertyid = atob(reconstructedpid)
    if (this.$root.id !== '') {
      if (this.$root.multiproperty === undefined) {
        this.multipropertyStatus = false
      } else {
        if (this.$root.multiproperty !== '') {
          this.multipropertyStatus = this.$root.multiproperty
        }
      }
    } else {
      this.multipropertyStatus = true
    }
    if (this.$store.state.roomNo !== '') {
      this.room = this.$store.state.roomNo
    }
    if (this.$store.state.promoCode !== '') {
      this.promo = this.$store.state.promoCode
    }
    if (this.$root.clientemail === undefined) {
      this.clientemail = false
    } else {
      if (this.$root.clientemail !== '') {
        this.clientemail = this.$root.clientemail
      }
    }
    this.bookings = this.$store.state.bookings
    var checkinDate = this.getUrlParameter('checkin_date')
    var checkouDate = this.getUrlParameter('checkout_date')
    if (this.$store.state.checkinDate) {
      var newDay = moment().format('YYYY-MM-DD')
      var nextNewDay = moment().add(1, 'days').format('YYYY-MM-DD')
      if (moment(this.$store.state.checkinDate).isBefore(newDay) === true) {
        this.checkoutdate1 = nextNewDay
        this.checkdate = newDay
        this.checkinDate = newDay
        this.chckinDate = newDay
        this.chckoutDate = nextNewDay
        this.checkoutDate = nextNewDay
      } else {
        this.checkdate = moment().format('YYYY-MM-DD')
        this.checkoutdate1 = this.$store.state.checkoutDate
        this.checkinDate = this.$store.state.checkinDate
        this.checkoutDate = this.$store.state.checkoutDate
        this.chckinDate = this.$store.state.checkinDate
        this.chckoutDate = this.$store.state.checkoutDate
      }
    } else {
      var checkinDate1 = checkinDate.toString()
      var momentcheckindateObj = moment(checkinDate1, 'DD-MM-YYYY')
      var checkoutDate1 = checkouDate.toString()
      var momentcheckoutdateObj = moment(checkoutDate1, 'DD-MM-YYYY')
      var newDate = momentcheckindateObj.format('YYYY-MM-DD')
      var futureDate = checkouDate !== '' ? momentcheckoutdateObj.format('YYYY-MM-DD') : moment(newDate).add(1, 'days').format('YYYY-MM-DD')
      var today = moment().format('YYYY-MM-DD')
      var tommorow = moment().add(1, 'days').format('YYYY-MM-DD')
      const checkinD = Date.parse(momentcheckindateObj)
      // const checkoutdd = Date.parse(momentcheckoutdateObj)
      if (isNaN(checkinD)) {
        this.checkoutdate1 = tommorow
        this.checkdate = today
        this.checkinDate = today
        this.chckInDate = today
        this.checkoutDate = tommorow
        this.chckOutDate = tommorow
      } else {
        if (moment(newDate).isBefore(today) === true) {
          this.checkoutdate1 = tommorow
          this.checkdate = today
          this.checkinDate = today
          this.chckinDate = today
          this.chckoutDate = tommorow
          this.checkoutDate = tommorow
        } else {
          this.checkoutdate1 = futureDate
          this.checkdate = newDate
          this.checkinDate = newDate
          this.chckinDate = newDate
          this.chckoutDate = futureDate
          this.checkoutDate = futureDate
        }
      }
    }
    this.period = this.calculateStayNights(this.checkinDate, this.checkoutDate)
    this.periodText = this.getPeriodText(this.period)
    this.fetchData()
    // this.multipropertyStatus = this.$root.multiproperty
    if (this.multipropertyStatus === true) {
      this.gettingMultiProperties()
    }
    // for testing
    if (this.$root.id === '') {
      this.gettingMultiProperties()
    }
    this.getPropertyDetails()
    this.guest = parseInt(this.adult)
    setInterval(() => this.nextPage(), 60000)
    const pageAccessedByReload = (
      (window.performance.navigation && window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType('navigation')
        .map((nav) => nav.type)
        .includes('reload')
    )
    if (pageAccessedByReload) {
      this.dateChanged = false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleMobileContinueScroll, { passive: true })
    this.handleMobileContinueScroll()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleMobileContinueScroll)
  },
  watch: {
    multiRoomResult: {
      handler () {
        this.$nextTick(this.handleMobileContinueScroll)
      },
      deep: true
    },
    chckinDate () {
      if (this.dateChanged) {
        let nextDate = this.chckinDate // event.target.value
        let stayrestrictions = this.bookings.data[this.propertyid].stay_restrictions
        if (stayrestrictions.length > 0) {
          for (const stayrestriction of stayrestrictions) {
            var startdate = moment(stayrestriction.start_date).subtract(1, 'days').format('YYYY-MM-DD')
            var enddate = moment(stayrestriction.end_date).add(1, 'days').format('YYYY-MM-DD')
            if (moment(this.chckinDate).isBetween(startdate, enddate) === true) {
              var minNights = stayrestriction.minimum_nights
              break
            } else {
              minNights = this.bookings.data[this.propertyid].minimum_nights
            }
          }
        } else {
          minNights = this.bookings.data[this.propertyid].minimum_nights
        }
        let checkoutnextDate = moment(nextDate).add(minNights, 'days').format('YYYY-MM-DD')
        this.chckoutDate = checkoutnextDate
        this.checkoutdate1 = checkoutnextDate
      } else {
        this.dateChanged = true
      }
    }
  },
  methods: {
    disabledRange (date) {
      const mindate = moment(this.checkoutdate1).subtract(1, 'day').format('YYYY-MM-DD')
      return date < new Date(mindate)
    },
    disableDateBeforeToday (date) {
      const todaysDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
      return date < new Date(todaysDate)
    },
    async getPropertyDetails () {
      const configUrl = process.env.CONFIG_URL['live_url']
      const key = process.env.PMS_KEY['key']
      const config = {
        headers: { 'Accept': 'application/json' }
      }
      const payload = {
        'property_id': this.propertyid,
        'api': this.type
      }
      const configRes = await this.$http.post(configUrl, payload, config)
      if (configRes.status === 200) {
        let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
        configData = JSON.parse(configData)
        this.secretKey = configData[0].val_ptoken // process.env.SECRET_KEY[this.propertyid].key
        this.consumerKey = configData[0].val_reserveport_secret_key // process.env.CONSUMER_KEY[this.propertyid].key
        const details = JSON.parse(configData[0].add_details)
        let fetchUrl = details.url
        this.postUrl = `${fetchUrl}/index.php`
        this.ppKey = configData[0].val_pesapal_Key // process.env.CONSUMER_PESAPAL_KEY[this.propertyid].key
        this.ppSecret = configData[0].val_pesapal_Secret // process.env.CONSUMER_PESAPAL_SECRET[this.propertyid].secret
      }
    },
    updateRoomFilter (propertyArr) {
      if (this.destination !== '') {
        var arrayFiltered = propertyArr.find(
          (x) => x.id === this.destination.toString()
        )
        this.filteredRoomTypeArray = arrayFiltered
      }
    },
    // below is commented since it does not need to override the global goToRoomDetail
    // gotoRoomDetail (roomid) {
    //   this.$router.push({
    //     path: '/room-details?rid=' + roomid + '&pid=' + btoa(this.propertyid)
    //   })
    // },
    getDateData () {
      if (this.$store.state.checkinDate) {
        this.checkdate = moment().format('YYYY-MM-DD')
        this.checkoutdate1 = this.$store.state.checkoutDate
        this.checkinDate = this.$store.state.checkinDate
        this.chckoutDate = this.$store.state.checkoutDate
        this.chckinDate = this.$store.state.checkinDate
        this.checkoutDate = this.$store.state.checkoutDate
        this.period = this.$store.state.period
      } else {
        var minimumCheckinNights =
          this.bookings.data[this.propertyid].minimum_checkin_nights
        var minimumNights = this.bookings.data[this.propertyid].minimum_nights
        if (minimumCheckinNights === 0) {
          var today = moment().format('YYYY-MM-DD')
          var tommorow = moment()
            .add(minimumNights, 'days')
            .format('YYYY-MM-DD')
          this.checkoutdate1 = tommorow
          this.checkdate = today
          this.checkinDate = today
          this.chckinDate = today
          this.chckoutDate = tommorow
          this.checkoutDate = tommorow
        }
        if (minimumCheckinNights > 0) {
          var checkoutRange = minimumCheckinNights + minimumNights
          var futureDate = moment()
            .add(minimumCheckinNights, 'days')
            .format('YYYY-MM-DD')
          var nextdate = moment()
            .add(checkoutRange, 'days')
            .format('YYYY-MM-DD')
          this.checkoutdate1 = nextdate
          this.checkdate = futureDate
          this.checkinDate = futureDate
          this.chckoutDate = nextdate
          this.chckinDate = futureDate
          this.checkoutDate = nextdate
        }
      }
      this.period = this.calculateStayNights(this.checkinDate, this.checkoutDate)
      this.periodText = this.getPeriodText(this.period)

      const roomdpayload = {
        checkindate: this.checkinDate,
        checkoutdate: this.checkoutDate
      }
      this.$store.commit('updateRoomCheckDates', roomdpayload)
    },
    openProofModal (multiRoomResult, selectedRooms) {
      this.bookingDataProof = multiRoomResult
      this.boardDataProof = selectedRooms
    },
    forceRerender () {
      this.componentKey += 1
    },
    updateChildAges (event, index) {
      this.childAges[index] = event.target.value
      this.childAges = this.childAges.filter(Boolean)
    },
    stickMenu () {
      var dropdowns = document.getElementsByClassName('dropdown-menu')
      var i
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i]
        if (openDropdown.classList.contains('hidden')) {
          openDropdown.classList.remove('hidden')
        }
      }
      document
        .getElementById('vue-dropdown-home')
        .addEventListener('click', function (event) {
          event.stopPropagation()
        })
      // Closes the menu in the event of outside click
      window.onclick = function (event) {
        if (!event.target.matches('.vue-small_large_select')) {
          var dropdowns = document.getElementsByClassName('dropdown-menu')

          var i
          for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i]
            if (openDropdown.classList.contains('show')) {
              openDropdown.classList.remove('show')
            }
          }
        }
      }
    },
    changeRoomImage (bindex, total, direction) {
      const current = this.roomImageIndex[bindex] || 0
      const next = (current + direction + total) % total
      this.$set(this.roomImageIndex, bindex, next)
    },
    scrollToSelection () {
      const target = this.$el.querySelector('#summery-submit')
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
    handleMobileContinueScroll () {
      const target = this.$el.querySelector('#summery-submit')
      if (!target) {
        this.hideMobileContinueBar = true
        return
      }
      const rect = target.getBoundingClientRect()
      this.hideMobileContinueBar = rect.top < window.innerHeight && rect.bottom > 0
    },
    close () {
      var dropdowns = document.getElementsByClassName('dropdown-menu')
      var i
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i]
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show')
        } else {
          openDropdown.classList.add('hidden')
        }
      }
    },
    changeCheckoutDate (event) {
      var nextDate = event.target.value
      var stayrestrictions =
        this.bookings.data[this.propertyid].stay_restrictions
      if (stayrestrictions.length > 0) {
        for (const stayrestriction of stayrestrictions) {
          var startdate = moment(stayrestriction.start_date)
            .subtract(1, 'days')
            .format('YYYY-MM-DD')
          var enddate = moment(stayrestriction.end_date)
            .add(1, 'days')
            .format('YYYY-MM-DD')
          if (moment(this.chckinDate).isBetween(startdate, enddate) === true) {
            var minNights = stayrestriction.minimum_nights
            break
          } else {
            minNights = this.bookings.data[this.propertyid].minimum_nights
          }
        }
      } else {
        minNights = this.bookings.data[this.propertyid].minimum_nights
      }
      var checkoutnextDate = moment(nextDate)
        .add(minNights, 'days')
        .format('YYYY-MM-DD')
      this.chckoutDate = checkoutnextDate
      this.checkoutdate1 = checkoutnextDate
    },
    addAdultCount () {
      this.defaultAdultNo = parseInt(this.defaultAdultNo) + 1
      this.guest = this.guest + 1
    },
    removeAdultCount () {
      if (this.defaultAdultNo > 1) {
        this.defaultAdultNo = parseInt(this.defaultAdultNo) - 1
        this.guest = this.guest - 1
      }
    },
    addBabiesCount () {
      this.defaultbabiesNo = parseInt(this.defaultbabiesNo) + 1
      this.guest = this.guest + 1
    },
    removeBabiesCount () {
      if (this.defaultbabiesNo > 0) {
        this.defaultbabiesNo = parseInt(this.defaultbabiesNo) - 1
        this.guest = this.guest - 1
      }
    },
    addChildrenCount () {
      this.defaultChildrenNo = parseInt(this.defaultChildrenNo) + 1
      this.childrenCount = this.defaultChildrenNo
      this.guest = this.guest + 1
    },
    removeChildrenCount () {
      if (this.defaultChildrenNo > 0) {
        this.defaultChildrenNo = parseInt(this.defaultChildrenNo) - 1
        this.guest = this.guest - 1
        this.childrenCount = this.defaultChildrenNo
      }
    },
    addRoom () {
      ++this.room
    },
    removeRoom () {
      if (this.room !== 1) {
        --this.room
      }
    },
    cancPolicy (bookid) {
      if (this.canc === bookid) {
        this.canc = null
      } else {
        this.canc = bookid
      }
      this.descr = null
      this.term = null
    },
    showPromoCode () {
      if (this.showpromo === false) {
        this.showpromo = true
      } else if (this.showpromo === true) {
        this.showpromo = false
      }
    },
    termCondition (bookid) {
      if (this.term === bookid) {
        this.term = null
      } else {
        this.term = bookid
      }
      this.descr = null
      this.canc = null
    },
    rdetail (bookid) {
      if (this.descr === bookid) {
        this.descr = null
      } else {
        this.descr = bookid
      }
      this.term = null
      this.canc = null
    },
    nonResident () {
      this.proof = false
      this.resident = 'non-resident'
      // this.updatePrices()
      var residentButton = document.getElementById('btnres')
      var nonresidentButton = document.getElementById('btnnonres')
      nonresidentButton.classList.add('active')
      residentButton.classList.remove('active')
      if (
        this.bookings.data[this.propertyid].currency.res !== '' &&
        this.bookings.data[this.propertyid].currency.nonres === ''
      ) {
        this.proofRes = 0
      } else if (
        this.bookings.data[this.propertyid].currency.res === '' &&
        this.bookings.data[this.propertyid].currency.nonres !== ''
      ) {
        this.proofRes = 1
      } else {
        this.proofRes = 1
      }
    },
    localResident () {
      this.proof = true
      this.resident = 'resident'
      if (
        this.bookings.data[this.propertyid].currency.res !== '' &&
        this.bookings.data[this.propertyid].currency.nonres === ''
      ) {
        this.proofRes = 0
      } else if (
        this.bookings.data[this.propertyid].currency.res === '' &&
        this.bookings.data[this.propertyid].currency.nonres !== ''
      ) {
        this.proofRes = 1
      } else {
        this.proofRes = 0
      }
      // this.updatePrices()
      var residentButton = document.getElementById('btnres')
      var nonresidentButton = document.getElementById('btnnonres')
      nonresidentButton.classList.remove('active')
      residentButton.classList.add('active')
    },
    findTotalRoomOccupant () {
      let adultcount = 0
      let childrenCount = 0
      let babiesCount = 0
      for (const result of Object.values(this.multiRoomResult)) {
        adultcount += result.adult
        childrenCount += result.children
        babiesCount += result.babies
      }
      this.totalAdultCount = adultcount
      this.totalChildrenCount = childrenCount
      this.totalBabiesCount = babiesCount
    },
    computeChildrenAgeRange (ageGroupsDetails) {
      var computedChildAges = []
      for (
        var i = parseInt(ageGroupsDetails.child_min_age); i <= parseInt(ageGroupsDetails.child_max_age); i++
      ) {
        computedChildAges.push({ age: i })
      }

      return computedChildAges
    },
    createDiv (board, index, roomid, booking) {
      var inputval = parseInt(
        document.getElementById('unit-selection-' + roomid + '-' + index).value,
        10
      )
      let roomAvailable = this.getAvailableRoom(booking.availability.available)
      if (roomAvailable > inputval) {
        this.divs.push({
          roomid: roomid,
          key: index,
          uniquekey: uuidv4(),
          adult: 0,
          ukey: Math.floor(Math.random() * 1000 + 1),
          children: 0,
          infant: 0,
          childrenAges: [],
          roomcount: 0,
          childrenSubmitedCount: 0,
          name: board.name
        })
        const divCount = this.divs.filter(
          (x) => x.key === index && x.roomid === roomid
        )
        this.count = divCount.length
        board.option = this.divs
        inputval = isNaN(inputval) ? 0 : inputval
        inputval++
        document.getElementById(
          'unit-selection-' + roomid + '-' + index
        ).value = inputval
      }
    },
    removeItem (indx, board, dt, room, index) {
      this.clicked = false
      this.divs = this.divs.filter((x) => x.ukey !== dt.ukey)
      if (this.divs.length >= 0) {
        var inputval = parseInt(
          document.getElementById('unit-selection-' + room.id + '-' + index)
            .value,
          10
        )
        inputval = isNaN(inputval) ? 0 : inputval
        inputval--
        document.getElementById(
          'unit-selection-' + room.id + '-' + index
        ).value = inputval
        this.roomId = room.id
        this.mealPlan = board.name
        var unitkey = room.id + '-' + index + '-' + dt.ukey
        delete this.multiRoomResult[unitkey]
        delete this.selectedRooms[unitkey]
        // removing all prices cart if  multiRoomResult is empty
        if (Object.keys(this.multiRoomResult).length === 0) {
          this.updatedPrices = {}
        }
        // updating prices
        this.children_ages = dt.childrenAges
        this.child = dt.children
        this.infant = dt.infant
        this.adultCount = dt.adult
        this.roomId = room.id
        this.mealPlan = board.name
        // const roomGuestTotal = this.child + this.infant + this.adultCount
        this.totalAdults = this.getTotalAdult(indx, room.id)
        this.totalChildren = this.getTotalChildren(indx, room.id)
        const payloadoccupancy = {
          totalAdult: this.totalAdults,
          totalChildren: this.totalChildren,
          totalBabies: this.totalBabies
        }
        this.$store.commit('updateOccupancy', payloadoccupancy)

        let mealplan = ''
        if (
          board.name.toLowerCase() === 'bed only' ||
          board.name.toLowerCase() === 'bed' || board.name.toLowerCase() === 'self catering'
        ) {
          mealplan = 'BO'
        } else if (board.name.toLowerCase() === 'bed & breakfast') {
          mealplan = 'BB'
        } else if (
          board.name.toLowerCase() === 'half board' ||
          board.name.toLowerCase() === 'halfboard'
        ) {
          mealplan = 'HB'
        } else if (
          board.name.toLowerCase() === 'fullboard' ||
          board.name.toLowerCase() === 'full board'
        ) {
          mealplan = 'FB'
        } else if (board.name.toLowerCase() === 'all inclusive') {
          mealplan = 'AI'
        }
        // rooming array
        // updating prices
        this.roomPrice = board.roomPrice
        this.totalRoomPrice = board.totalRoomPrice
        this.subTotal = board.subTotal
        this.totalGatewayFee = board.totalGatewayFee
        this.roomDiscount = board.roomDiscount
        this.totalDiscount = board.totalDiscount
        this.total = board.totalAmountPayable
        this.serviceCharge = board.totalServiceCharge
        this.totalVat = board.totalVAT
        this.hotelTax = board.totalHotelTax

        if (Object.keys(this.updatedPrices).length === 0) {
          this.roomSummary = {
            totalDiscount: {},
            subTotal: {},
            serviceCharge: {},
            totalHotelTax: {},
            totalVAT: {},
            totalRoomPrice: {}
          }
        }
        if (Object.keys(this.updatedPrices).length === 0) {
          var initTotalDiscount = {
            res: 0,
            nonres: 0,
            rooms: this.roomSummary.totalDiscount
          }
          var initSubTotal = {
            res: 0,
            nonres: 0,
            rooms: this.roomSummary.subTotal
          }
          var initTotalServiceCharge = {
            res: 0,
            nonres: 0,
            rooms: this.roomSummary.serviceCharge
          }
          var initTotalHotelTax = {
            res: 0,
            nonres: 0,
            rooms: this.roomSummary.totalHotelTax
          }
          var initTotalVAT = {
            res: 0,
            nonres: 0,
            rooms: this.roomSummary.totalVAT
          }
          var initTotalGatewayFee = { res: 0, nonres: 0 }
          var initTotalAmountPayable = { res: 0, nonres: 0 }
          var initTotalRoomPrice = {
            res: 0,
            nonres: 0,
            rooms: this.roomSummary.totalRoomPrice
          }
        } else {
          initTotalDiscount = {
            res: this.updatedPrices.initTotalDiscount.res,
            nonres: this.updatedPrices.initTotalDiscount.nonres,
            rooms: this.roomSummary.totalDiscount
          }
          initSubTotal = {
            res: this.updatedPrices.initSubTotal.res,
            nonres: this.updatedPrices.initSubTotal.nonres,
            rooms: this.roomSummary.subTotal
          }
          initTotalServiceCharge = {
            res: this.updatedPrices.initTotalServiceCharge.res,
            nonres: this.updatedPrices.initTotalServiceCharge.nonres,
            rooms: this.roomSummary.serviceCharge
          }
          initTotalHotelTax = {
            res: this.updatedPrices.initTotalHotelTax.res,
            nonres: this.updatedPrices.initTotalHotelTax.nonres,
            rooms: this.roomSummary.totalHotelTax
          }
          initTotalVAT = {
            res: this.updatedPrices.initTotalVAT.res,
            nonres: this.updatedPrices.initTotalVAT.nonres,
            rooms: this.roomSummary.totalVAT
          }
          initTotalGatewayFee = this.updatedPrices.initTotalGatewayFee
          initTotalAmountPayable = this.updatedPrices.initTotalAmountPayable
          initTotalRoomPrice = {
            res: this.updatedPrices.initTotalRoomPrice.res,
            nonres: this.updatedPrices.initTotalRoomPrice.nonres,
            rooms: this.roomSummary.totalRoomPrice
          }
        }

        const postData = {
          room_id: room.id,
          adults: 0,
          children: 0,
          children_ages: [],
          babies: 0,
          room_count: dt.roomcount,
          coupon_code: this.promo,
          checkin_date: this.checkinDate,
          checkout_date: this.checkoutDate,
          meal_plan: mealplan,
          totalDiscount: initTotalDiscount,
          subTotal: initSubTotal,
          totalServiceCharge: initTotalServiceCharge,
          totalHotelTax: initTotalHotelTax,
          totalVAT: initTotalVAT,
          totalGatewayFee: initTotalGatewayFee,
          totalRoomPrice: initTotalRoomPrice,
          totalAmountPayable: initTotalAmountPayable
        }

        var adultpostDataJson = JSON.stringify(postData)
        var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
        var encryptedPostData = this.CryptoJSAesEncrypt(
          passkey,
          adultpostDataJson
        )
        var url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.removeRoom&pid=${this.propertyid}&consumer_key= ${this.consumerKey}&data=${encryptedPostData}`
        this.axios
          .get(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            var responseData = response.data.er
            var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
            return JSON.parse(decryptedData)
          })
          .then((data) => {
            if (data.hasOwnProperty('error') !== false) {
              this.errormsg = data.msg
            } else {
              // unitkey = room.id + '-' + indx + '-' + dt.ukey
              this.roomSummary = {
                totalDiscount: data.totalDiscount.rooms,
                subTotal: data.subTotal.rooms,
                serviceCharge: data.totalServiceCharge.rooms,
                totalHotelTax: data.totalHotelTax.rooms,
                totalVAT: data.totalVAT.rooms,
                totalRoomPrice: data.totalRoomPrice.rooms
              }

              this.roomPrice = data.roomPrice
              this.totalRoomPrice = data.totalRoomPrice
              this.subTotal = data.subTotal
              this.totalGatewayFee = data.totalGatewayFee
              this.roomDiscount = data.roomDiscount
              this.totalDiscount = data.totalDiscount
              this.total = data.totalAmountPayable
              this.serviceCharge = data.totalServiceCharge
              this.totalVat = data.totalVAT
              this.hotelTax = data.totalHotelTax

              // updating value of session
              this.updatedPrices = {
                initTotalDiscount: data.totalDiscount,
                initSubTotal: data.subTotal,
                initTotalServiceCharge: data.totalServiceCharge,
                initTotalHotelTax: data.totalHotelTax,
                initTotalVAT: data.totalVAT,
                initTotalGatewayFee: data.totalGatewayFee,
                initTotalAmountPayable: data.totalAmountPayable,
                initTotalRoomPrice: data.totalRoomPrice
              }

              // endformating
              const payload = {
                servicecharges: this.serviceCharge,
                totalvat: this.totalVat,
                hoteltax: this.hotelTax,
                total: this.total,
                discount: this.totalDiscount,
                GatewayFee: this.totalGatewayFee
              }
              this.$store.dispatch('updatePrices', payload)
              this.multi_result = true
              if (dt.roomcount > 0) {
                dt.roomcount = parseInt(dt.roomcount) - 1
              }
              this.findTotalRoomOccupant()
              setTimeout(() => {
                this.clicked = false
              }, 1000)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    deleteDiv (board, indx, roomid) { },
    getTotalGuest (index, roomid) {
      const divarr = this.divs.filter(
        (x) => x.key === index && x.roomid === roomid
      )
      let totalPeople = 0
      divarr.forEach((arr) => {
        totalPeople = totalPeople + arr.adult + arr.infant + arr.children
      })
      return totalPeople
    },
    getTotalAdult (index, roomid) {
      const divarr = this.divs.filter(
        (x) => x.key === index && x.roomid === roomid
      )
      let totalAdult = 0
      divarr.forEach((arr) => {
        totalAdult = totalAdult + arr.adult
      })
      return totalAdult
    },
    getTotalChildren (index, roomid) {
      const divarr = this.divs.filter(
        (x) => x.key === index && x.roomid === roomid
      )
      let totalchildren = 0
      divarr.forEach((arr) => {
        totalchildren = totalchildren + arr.children
      })
      return totalchildren
    },
    async addAdult (index, room, board, dt, indx) {
      var loader = document.getElementById('loading-' + room.id + '-' + dt.key)
      var loaderCover = document.getElementById(
        'loading-cover-' + room.id + '-' + dt.key
      )
      loader.style.display = 'block'
      loaderCover.style.opacity = 0.3
      var inputval = parseInt(
        document.getElementById('adult-' + dt.ukey).value,
        10
      )
      inputval = isNaN(inputval) ? 0 : inputval
      if (room.occupancy.maximumAdultOccupancy > inputval) {
        inputval++
        this.clicked = true
        this.children_ages = dt.childrenAges
        this.child = dt.children
        this.infant = dt.infant
        this.adultCount = dt.adult
        this.roomId = room.id
        this.mealPlan = board.name
        const roomGuestTotal = this.child + this.infant + this.adultCount
        if (room.occupancy.maximumTotalOccupancy > roomGuestTotal) {
          ++dt.adult
          document.getElementById('adult-' + dt.ukey).value = dt.adult
          this.totalAdults = this.getTotalAdult(indx, room.id)
          this.totalChildren = this.getTotalChildren(indx, room.id)
          const payloadoccupancy = {
            totalAdult: this.totalAdults,
            totalChildren: this.totalChildren,
            totalBabies: this.totalBabies
          }
          this.$store.commit('updateOccupancy', payloadoccupancy)

          var mealplan = ''
          if (
            board.name.toLowerCase() === 'bed only' ||
            board.name.toLowerCase() === 'bed' || board.name.toLowerCase() === 'self catering'
          ) {
            mealplan = 'BO'
          } else if (board.name.toLowerCase() === 'bed & breakfast') {
            mealplan = 'BB'
          } else if (
            board.name.toLowerCase() === 'half board' ||
            board.name.toLowerCase() === 'halfboard'
          ) {
            mealplan = 'HB'
          } else if (
            board.name.toLowerCase() === 'fullboard' ||
            board.name.toLowerCase() === 'full board'
          ) {
            mealplan = 'FB'
          } else if (board.name.toLowerCase() === 'all inclusive') {
            mealplan = 'AI'
          }
          this.selectedBoard.push(mealplan)
          var filteredBoards = []
          var count = 0
          var start = false
          for (var j = 0; j < this.selectedBoard.length; j++) {
            for (var k = 0; k < filteredBoards.length; k++) {
              if (this.selectedBoard[j] === filteredBoards[k]) {
                start = true
              }
            }
            count++
            if (count === 1 && start === false) {
              filteredBoards.push(this.selectedBoard[j])
            }
            start = false
            count = 0
          }
          // rooming array
          // updating prices
          this.roomPrice = board.roomPrice
          this.totalRoomPrice = board.totalRoomPrice
          this.subTotal = board.subTotal
          this.totalGatewayFee = board.totalGatewayFee
          this.roomDiscount = board.roomDiscount
          this.totalDiscount = board.totalDiscount
          this.total = board.totalAmountPayable
          this.serviceCharge = board.totalServiceCharge
          this.totalVat = board.totalVAT
          this.hotelTax = board.totalHotelTax

          if (Object.keys(this.updatedPrices).length === 0) {
            this.roomSummary = {
              totalDiscount: {},
              subTotal: {},
              serviceCharge: {},
              totalHotelTax: {},
              totalVAT: {},
              totalRoomPrice: {}
            }
          }
          if (Object.keys(this.updatedPrices).length === 0) {
            var initTotalDiscount = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.totalDiscount
            }
            var initSubTotal = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.subTotal
            }
            var initTotalServiceCharge = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.serviceCharge
            }
            var initTotalHotelTax = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.totalHotelTax
            }
            var initTotalVAT = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.totalVAT
            }
            var initTotalGatewayFee = { res: 0, nonres: 0 }
            var initTotalAmountPayable = { res: 0, nonres: 0 }
            var initTotalRoomPrice = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.totalRoomPrice
            }
          } else {
            initTotalDiscount = {
              res: this.updatedPrices.initTotalDiscount.res,
              nonres: this.updatedPrices.initTotalDiscount.nonres,
              rooms: this.roomSummary.totalDiscount
            }
            initSubTotal = {
              res: this.updatedPrices.initSubTotal.res,
              nonres: this.updatedPrices.initSubTotal.nonres,
              rooms: this.roomSummary.subTotal
            }
            initTotalServiceCharge = {
              res: this.updatedPrices.initTotalServiceCharge.res,
              nonres: this.updatedPrices.initTotalServiceCharge.nonres,
              rooms: this.roomSummary.serviceCharge
            }
            initTotalHotelTax = {
              res: this.updatedPrices.initTotalHotelTax.res,
              nonres: this.updatedPrices.initTotalHotelTax.nonres,
              rooms: this.roomSummary.totalHotelTax
            }
            initTotalVAT = {
              res: this.updatedPrices.initTotalVAT.res,
              nonres: this.updatedPrices.initTotalVAT.nonres,
              rooms: this.roomSummary.totalVAT
            }
            initTotalGatewayFee = this.updatedPrices.initTotalGatewayFee
            initTotalAmountPayable = this.updatedPrices.initTotalAmountPayable
            initTotalRoomPrice = {
              res: this.updatedPrices.initTotalRoomPrice.res,
              nonres: this.updatedPrices.initTotalRoomPrice.nonres,
              rooms: this.roomSummary.totalRoomPrice
            }
          }

          const adultpostData = {
            room_id: room.id,
            adults: dt.adult,
            children: dt.children,
            children_ages: dt.childrenAges,
            babies: dt.infant,
            room_count: index + 1,
            coupon_code: this.promo,
            checkin_date: this.checkinDate,
            checkout_date: this.checkoutDate,
            meal_plan: mealplan,
            totalDiscount: initTotalDiscount,
            subTotal: initSubTotal,
            totalServiceCharge: initTotalServiceCharge,
            totalHotelTax: initTotalHotelTax,
            totalVAT: initTotalVAT,
            totalGatewayFee: initTotalGatewayFee,
            totalRoomPrice: initTotalRoomPrice,
            totalAmountPayable: initTotalAmountPayable
          }
          dt.roomcount = index + 1
          var adultpostDataJson = JSON.stringify(adultpostData)
          var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
          var encryptedPostData = this.CryptoJSAesEncrypt(
            passkey,
            adultpostDataJson
          )

          // submiting data
          try {
            const url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.calculateRoomPrice`
            const formData = new FormData()
            formData.append('pid', this.propertyid)
            formData.append('consumer_key', this.consumerKey)
            formData.append('data', encryptedPostData)
            const response = await this.axios.post(url, formData)
            if (response) {
              let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
              this.errors = false
              this.errorMsg = []
              if (data !== '') {
                data = JSON.parse(data)
                if (data.hasOwnProperty('error') !== false) {
                  this.errormsg = data.msg
                } else {
                  var unitkey = room.id + '-' + indx + '-' + dt.ukey
                  this.multiRoomResult[unitkey] = {
                    id: room.id,
                    data: data,
                    room: room,
                    adult: dt.adult,
                    children: dt.children,
                    babies: dt.infant,
                    boards: filteredBoards
                  }
                  this.roomSummary = {
                    totalDiscount: data.totalDiscount.rooms,
                    subTotal: data.subTotal.rooms,
                    serviceCharge: data.totalServiceCharge.rooms,
                    totalHotelTax: data.totalHotelTax.rooms,
                    totalVAT: data.totalVAT.rooms,
                    totalRoomPrice: data.totalRoomPrice.rooms
                  }

                  this.roomPrice = data.roomPrice
                  this.totalRoomPrice = data.totalRoomPrice
                  this.subTotal = data.subTotal
                  this.totalGatewayFee = data.totalGatewayFee
                  this.roomDiscount = data.roomDiscount
                  this.totalDiscount = data.totalDiscount
                  this.total = data.totalAmountPayable
                  this.serviceCharge = data.totalServiceCharge
                  this.totalVat = data.totalVAT
                  this.hotelTax = data.totalHotelTax

                  // updating value of session
                  this.updatedPrices = {
                    initTotalDiscount: data.totalDiscount,
                    initSubTotal: data.subTotal,
                    initTotalServiceCharge: data.totalServiceCharge,
                    initTotalHotelTax: data.totalHotelTax,
                    initTotalVAT: data.totalVAT,
                    initTotalGatewayFee: data.totalGatewayFee,
                    initTotalAmountPayable: data.totalAmountPayable,
                    initTotalRoomPrice: data.totalRoomPrice
                  }

                  // getting coupons
                  var couponDetail = {}
                  for (const coupon of Object.values(room.discount_coupons)) {
                    couponDetail = {
                      id: coupon.id,
                      code: coupon.code,
                      name: coupon.code,
                      boards: coupon.boards,
                      start_date: coupon.start_date,
                      end_date: coupon.end_date,
                      type: coupon.type
                    }
                  }
                  let totalpayble = 0
                  let dailyAdultRate = 0
                  let totalDailtRate = 0
                  let totalChildrenDailyRate = 0
                  let totalDailyDiscountRate = 0
                  if (this.proofRes === 0) {
                    totalpayble = data.roomPrice.res
                    dailyAdultRate = data.roomPrice.daily.adults.res
                    totalDailtRate = data.roomPrice.daily.res
                    totalChildrenDailyRate = data.roomPrice.daily.children.res
                    totalDailyDiscountRate = data.roomDiscount.daily.res
                  } else {
                    totalpayble = data.roomPrice.nonres
                    dailyAdultRate = data.roomPrice.daily.adults.nonres
                    totalDailtRate = data.roomPrice.daily.nonres
                    totalChildrenDailyRate = data.roomPrice.daily.children.nonres
                    totalDailyDiscountRate = data.roomDiscount.daily.nonres
                  }
                  // formating room data to be posted
                  this.selectedRooms[unitkey] = {
                    id: room.id,
                    total_adult: dt.adult,
                    name: room.name,
                    no_rooms: 1,
                    cguest: dt.children,
                    children_ages: dt.childrenAges,
                    bguest: dt.infant,
                    meal_plan: mealplan,
                    totalprice_book: totalpayble,
                    coupon_details: JSON.stringify(couponDetail),
                    daily_rates: {
                      total: totalDailtRate,
                      adults: dailyAdultRate,
                      children: totalChildrenDailyRate,
                      discount: totalDailyDiscountRate
                    }
                  }
                  // endformating
                  const payload = {
                    subtotal: this.subTotal,
                    servicecharges: this.serviceCharge,
                    totalvat: this.totalVat,
                    hoteltax: this.hotelTax,
                    total: this.total,
                    discount: this.totalDiscount,
                    GatewayFee: this.totalGatewayFee
                  }
                  this.$store.dispatch('updatePrices', payload)
                  this.multi_result = true
                  this.findTotalRoomOccupant()
                  this.$nextTick(this.handleMobileContinueScroll)
                  setTimeout(() => {
                    this.clicked = false
                    loader.style.display = 'none'
                    loaderCover.style.opacity = 1
                  }, 1000)
                }
              }
            }
          } catch (error) { }
          // end
        } else {
          loader.style.display = 'none'
          loaderCover.style.opacity = 1
          this.clicked = false
        }
      } else {
        loader.style.display = 'none'
        loaderCover.style.opacity = 1
        this.clicked = false
      }
    },
    async updateChildren (event, room, index, board, data, indx, chindex) {
      // const noOfRooms = index + 1
      var loader = document.getElementById(
        'loading-' + room.id + '-' + data.key
      )
      var loaderCover = document.getElementById(
        'loading-cover-' + room.id + '-' + data.key
      )
      loaderCover.style.opacity = 0.3
      loader.style.display = 'block'
      data.childrenAges[chindex] = event.target.value
      this.children_ages = data.childrenAges
      this.clicked = true
      this.child = data.children
      this.infant = data.infant
      this.adultCount = data.adult
      this.roomId = room.id
      this.mealPlan = board.name
      // const totalGuest = this.getTotalGuest(indx, room.id)
      this.totalAdults = this.getTotalAdult(indx, room.id)
      this.totalChildren = this.getTotalChildren(indx, room.id)
      const payloadoccupancy = {
        totalAdult: this.totalAdults,
        totalChildren: this.totalChildren,
        totalBabies: this.totalBabies
      }
      this.$store.dispatch('updateOccupancy', payloadoccupancy)

      var selectedBoard = []
      var mealplan = ''
      if (
        board.name.toLowerCase() === 'bed only' ||
        board.name.toLowerCase() === 'bed' || board.name.toLowerCase() === 'self catering'
      ) {
        mealplan = 'BO'
      } else if (board.name.toLowerCase() === 'bed & breakfast') {
        mealplan = 'BB'
      } else if (
        board.name.toLowerCase() === 'half board' ||
        board.name.toLowerCase() === 'halfboard'
      ) {
        mealplan = 'HB'
      } else if (
        board.name.toLowerCase() === 'fullboard' ||
        board.name.toLowerCase() === 'full board'
      ) {
        mealplan = 'FB'
      } else if (board.name.toLowerCase() === 'all inclusive') {
        mealplan = 'AI'
      }
      selectedBoard.push(mealplan)
      // updating prices
      this.roomPrice = board.roomPrice
      this.totalRoomPrice = board.totalRoomPrice
      this.subTotal = board.subTotal
      this.totalGatewayFee = board.totalGatewayFee
      this.roomDiscount = board.roomDiscount
      this.totalDiscount = board.totalDiscount
      this.total = board.totalAmountPayable
      this.serviceCharge = board.totalServiceCharge
      this.totalVat = board.totalVAT
      this.hotelTax = board.totalHotelTax
      //  updating prices payload
      if (Object.keys(this.updatedPrices).length === 0) {
        this.roomSummary = {
          totalDiscount: {},
          subTotal: {},
          serviceCharge: {},
          totalHotelTax: {},
          totalVAT: {},
          totalRoomPrice: {}
        }
        var initTotalDiscount = {
          res: 0,
          nonres: 0,
          rooms: this.roomSummary.totalDiscount
        }
        var initSubTotal = {
          res: 0,
          nonres: 0,
          rooms: this.roomSummary.subTotal
        }
        var initTotalServiceCharge = {
          res: 0,
          nonres: 0,
          rooms: this.roomSummary.serviceCharge
        }
        var initTotalHotelTax = {
          res: 0,
          nonres: 0,
          rooms: this.roomSummary.totalHotelTax
        }
        var initTotalVAT = {
          res: 0,
          nonres: 0,
          rooms: this.roomSummary.totalVAT
        }
        var initTotalGatewayFee = { res: 0, nonres: 0 }
        var initTotalAmountPayable = { res: 0, nonres: 0 }
        var initTotalRoomPrice = {
          res: 0,
          nonres: 0,
          rooms: this.roomSummary.totalRoomPrice
        }
      } else {
        initTotalDiscount = {
          res: this.updatedPrices.initTotalDiscount.res,
          nonres: this.updatedPrices.initTotalDiscount.nonres,
          rooms: this.roomSummary.totalDiscount
        }
        initSubTotal = {
          res: this.updatedPrices.initSubTotal.res,
          nonres: this.updatedPrices.initSubTotal.nonres,
          rooms: this.roomSummary.subTotal
        }
        initTotalServiceCharge = {
          res: this.updatedPrices.initTotalServiceCharge.res,
          nonres: this.updatedPrices.initTotalServiceCharge.nonres,
          rooms: this.roomSummary.serviceCharge
        }
        initTotalHotelTax = {
          res: this.updatedPrices.initTotalHotelTax.res,
          nonres: this.updatedPrices.initTotalHotelTax.nonres,
          rooms: this.roomSummary.totalHotelTax
        }
        initTotalVAT = {
          res: this.updatedPrices.initTotalVAT.res,
          nonres: this.updatedPrices.initTotalVAT.nonres,
          rooms: this.roomSummary.totalVAT
        }
        initTotalGatewayFee = this.updatedPrices.initTotalGatewayFee
        initTotalAmountPayable = this.updatedPrices.initTotalAmountPayable
        initTotalRoomPrice = {
          res: this.updatedPrices.initTotalRoomPrice.res,
          nonres: this.updatedPrices.initTotalRoomPrice.nonres,
          rooms: this.roomSummary.totalRoomPrice
        }
      }

      const childrenpostData = {
        room_id: room.id,
        adults: data.adult,
        children: data.children,
        children_ages: data.childrenAges,
        room_count: index + 1,
        babies: data.infant,
        coupon_code: this.promo,
        checkin_date: this.checkinDate,
        checkout_date: this.checkoutDate,
        meal_plan: mealplan,
        totalDiscount: initTotalDiscount,
        subTotal: initSubTotal,
        totalServiceCharge: initTotalServiceCharge,
        totalHotelTax: initTotalHotelTax,
        totalVAT: initTotalVAT,
        totalGatewayFee: initTotalGatewayFee,
        totalRoomPrice: initTotalRoomPrice,
        totalAmountPayable: initTotalAmountPayable
      }
      data.roomcount = index + 1
      var adultpostDataJson = JSON.stringify(childrenpostData)
      var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
      var encryptedPostData = this.CryptoJSAesEncrypt(
        passkey,
        adultpostDataJson
      )
      try {
        const url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.calculateRoomPrice`
        const formData = new FormData()
        formData.append('pid', this.propertyid)
        formData.append('consumer_key', this.consumerKey)
        formData.append('data', encryptedPostData)
        const response = await this.axios.post(url, formData)
        if (response) {
          let result = this.CryptoJSAesDecrypt(passkey, response.data.er)
          this.errors = false
          this.errorMsg = []
          if (result !== '') {
            result = JSON.parse(result)
            if (result.hasOwnProperty('error') !== false) {
              this.errormsg = result.msg
            } else {
              let uniquekey = room.id + '-' + indx + '-' + data.ukey
              this.multiRoomResult[uniquekey] = {
                id: room.id,
                data: result,
                room: room,
                adult: data.adult,
                children: data.children,
                babies: data.infant,
                boards: selectedBoard
              }
              data.childrenSubmitedCount = data.children
              this.roomSummary = {
                totalDiscount: result.totalDiscount.rooms,
                subTotal: result.subTotal.rooms,
                serviceCharge: result.totalServiceCharge.rooms,
                totalHotelTax: result.totalHotelTax.rooms,
                totalVAT: result.totalVAT.rooms,
                totalRoomPrice: result.totalRoomPrice.rooms
              }

              // updating prices
              this.roomPrice = result.roomPrice
              this.totalRoomPrice = result.totalRoomPrice
              this.subTotal = result.subTotal
              this.totalGatewayFee = result.totalGatewayFee
              this.roomDiscount = result.roomDiscount
              this.totalDiscount = result.totalDiscount
              this.total = result.totalAmountPayable
              this.serviceCharge = result.totalServiceCharge
              this.totalVat = result.totalVAT
              this.hotelTax = result.totalHotelTax

              // updating prices
              this.updatedPrices = {
                initTotalDiscount: result.totalDiscount,
                initSubTotal: result.subTotal,
                initTotalServiceCharge: result.totalServiceCharge,
                initTotalHotelTax: result.totalHotelTax,
                initTotalVAT: result.totalVAT,
                initTotalGatewayFee: result.totalGatewayFee,
                initTotalAmountPayable: result.totalAmountPayable,
                initTotalRoomPrice: result.totalRoomPrice
              }
              // getting coupons
              var couponDetail = {}
              for (const coupon of Object.values(room.discount_coupons)) {
                couponDetail = {
                  id: coupon.id,
                  code: coupon.code,
                  name: coupon.code,
                  boards: coupon.boards,
                  start_date: coupon.start_date,
                  end_date: coupon.end_date,
                  type: coupon.type
                }
              }

              let totalpayble = 0
              let dailyAdultRate = 0
              let totalDailtRate = 0
              let totalChildrenDailyRate = 0
              let totalDailyDiscountRate = 0
              if (this.proofRes === 0) {
                totalpayble = result.roomPrice.res
                dailyAdultRate = result.roomPrice.daily.adults.res
                totalDailtRate = result.roomPrice.daily.res
                totalChildrenDailyRate = result.roomPrice.daily.children.res
                totalDailyDiscountRate = result.roomDiscount.daily.res
              } else {
                totalpayble = result.roomPrice.nonres
                dailyAdultRate = result.roomPrice.daily.adults.nonres
                totalDailtRate = result.roomPrice.daily.nonres
                totalChildrenDailyRate = result.roomPrice.daily.children.nonres
                totalDailyDiscountRate = result.roomDiscount.daily.nonres
              } // formating room data to be posted
              this.selectedRooms[uniquekey] = {
                id: room.id,
                total_adult: data.adult,
                name: room.name,
                no_rooms: 1,
                cguest: data.children,
                children_ages: this.children_ages,
                bguest: data.infant,
                meal_plan: mealplan,
                totalprice_book: totalpayble,
                coupon_details: JSON.stringify(couponDetail),
                daily_rates: {
                  total: totalDailtRate,
                  adults: dailyAdultRate,
                  children: totalChildrenDailyRate,
                  discount: totalDailyDiscountRate
                }
              }
              // endformating
              const payload = {
                subtotal: this.subTotal,
                servicecharges: this.serviceCharge,
                totalvat: this.totalVat,
                hoteltax: this.hotelTax,
                total: this.total,
                discount: this.totalDiscount,
                GatewayFee: this.totalGatewayFee
              }
              this.$store.dispatch('updatePrices', payload)
              this.multi_result = true
              this.findTotalRoomOccupant()
              setTimeout(() => {
                loader.style.display = 'none'
                loaderCover.style.opacity = 1
                this.clicked = false
              }, 1000)
            }
          } else {
            loader.style.display = 'none'
            loaderCover.style.opacity = 1
          }
        }
      } catch (error) {
        loader.style.display = 'none'
        loaderCover.style.opacity = 1
      }
    },
    addChild (data, room) {
      // maximumChildSharingOccupancy
      if (
        this.bookings.data[this.propertyid].age_group_details
          .children_allowed !== 0
      ) {
        this.child = data.children
        this.infant = data.infant
        this.adultCount = data.adult
        var inputval = parseInt(
          document.getElementById('children-' + data.ukey).value,
          10
        )
        inputval = isNaN(inputval) ? 0 : inputval
        const roomGuestTotal = this.child + this.infant + this.adultCount
        if (room.occupancy.maximumTotalOccupancy > roomGuestTotal) {
          if (data.adult >= room.occupancy.minimumAdultOccupancy) {
            if (room.occupancy.maximumChildOnlyOccupancy > inputval) {
              ++data.children
              document.getElementById('children-' + data.ukey).value =
                data.children
              this.children = data.children
            } else if (data.adult > 0 && room.occupancy.maximumChildSharingOccupancy > inputval) {
              ++data.children
              document.getElementById('children-' + data.ukey).value =
                data.children
              this.children = data.children
            } else {
              this.$alert(
                'Children are not allowed in this room.',
                '',
                'warning'
              )
            }
          } else {
            this.$alert(
              `Please select at least ${room.occupancy.minimumAdultOccupancy} Adult(s) in Room`,
              '',
              'warning'
            )
          }
        } else {
          this.$alert(
            'Maximum guest total reached.',
            '',
            'warning'
          )
        }
      } else {
        this.$alert(
          'Children are not allowed.',
          '',
          'warning'
        )
      }
    },
    async removeChild (index, room, board, dt, indx) {
      var inputval = parseInt(
        document.getElementById('children-' + dt.ukey).value,
        10
      )
      inputval = isNaN(inputval) ? 0 : inputval
      if (inputval !== 0) {
        --dt.children
        this.children = dt.children
        document.getElementById('children-' + dt.ukey).value = dt.children
        // const noOfRooms = index + 1
        this.children_ages = dt.childrenAges
        this.child = dt.children
        this.infant = dt.infant
        this.adultCount = dt.adult
        this.roomId = room.id
        this.mealPlan = board.name
        var untkey = dt.ukey
        // const totalGuest = this.getTotalGuest(indx, room.id)
        this.totalAdults = this.getTotalAdult(indx, room.id)
        this.totalChildren = this.getTotalChildren(indx, room.id)
        const payloadoccupancy = {
          totalAdult: this.totalAdults,
          totalChildren: this.totalChildren,
          totalBabies: this.totalBabies
        }
        this.$store.commit('updateOccupancy', payloadoccupancy)
        var selectedBoard = []
        var mealplan = ''
        if (
          board.name.toLowerCase() === 'bed only' ||
          board.name.toLowerCase() === 'bed' || board.name.toLowerCase() === 'self catering'
        ) {
          mealplan = 'BO'
        } else if (board.name.toLowerCase() === 'bed & breakfast') {
          mealplan = 'BB'
        } else if (
          board.name.toLowerCase() === 'half board' ||
          board.name.toLowerCase() === 'halfboard'
        ) {
          mealplan = 'HB'
        } else if (
          board.name.toLowerCase() === 'fullboard' ||
          board.name.toLowerCase() === 'full board'
        ) {
          mealplan = 'FB'
        } else if (board.name.toLowerCase() === 'all inclusive') {
          mealplan = 'AI'
        }
        selectedBoard.push(mealplan)
        // updating prices
        this.roomPrice = board.roomPrice
        this.totalRoomPrice = board.totalRoomPrice
        this.subTotal = board.subTotal
        this.totalGatewayFee = board.totalGatewayFee
        this.roomDiscount = board.roomDiscount
        this.totalDiscount = board.totalDiscount
        this.total = board.totalAmountPayable
        this.serviceCharge = board.totalServiceCharge
        this.totalVat = board.totalVAT
        this.hotelTax = board.totalHotelTax
        if (dt.childrenSubmitedCount > 0) {
          var loader = document.getElementById(
            'loading-' + room.id + '-' + dt.key
          )
          var loaderCover = document.getElementById(
            'loading-cover-' + room.id + '-' + dt.key
          )
          loaderCover.style.opacity = 0.3
          loader.style.display = 'block'
          this.clicked = true
          //  updating prices payload
          if (Object.keys(this.updatedPrices).length === 0) {
            this.roomSummary = {
              totalDiscount: {},
              subTotal: {},
              serviceCharge: {},
              totalHotelTax: {},
              totalVAT: {},
              totalRoomPrice: {}
            }
          }
          if (Object.keys(this.updatedPrices).length === 0) {
            var initTotalDiscount = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.totalDiscount
            }
            var initSubTotal = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.subTotal
            }
            var initTotalServiceCharge = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.serviceCharge
            }
            var initTotalHotelTax = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.totalHotelTax
            }
            var initTotalVAT = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.totalVAT
            }
            var initTotalGatewayFee = { res: 0, nonres: 0 }
            var initTotalAmountPayable = { res: 0, nonres: 0 }
            var initTotalRoomPrice = {
              res: 0,
              nonres: 0,
              rooms: this.roomSummary.totalRoomPrice
            }
          } else {
            initTotalDiscount = {
              res: this.updatedPrices.initTotalDiscount.res,
              nonres: this.updatedPrices.initTotalDiscount.nonres,
              rooms: this.roomSummary.totalDiscount
            }
            initSubTotal = {
              res: this.updatedPrices.initSubTotal.res,
              nonres: this.updatedPrices.initSubTotal.nonres,
              rooms: this.roomSummary.subTotal
            }
            initTotalServiceCharge = {
              res: this.updatedPrices.initTotalServiceCharge.res,
              nonres: this.updatedPrices.initTotalServiceCharge.nonres,
              rooms: this.roomSummary.serviceCharge
            }
            initTotalHotelTax = {
              res: this.updatedPrices.initTotalHotelTax.res,
              nonres: this.updatedPrices.initTotalHotelTax.nonres,
              rooms: this.roomSummary.totalHotelTax
            }
            initTotalVAT = {
              res: this.updatedPrices.initTotalVAT.res,
              nonres: this.updatedPrices.initTotalVAT.nonres,
              rooms: this.roomSummary.totalVAT
            }
            initTotalGatewayFee = this.updatedPrices.initTotalGatewayFee
            initTotalAmountPayable = this.updatedPrices.initTotalAmountPayable
            initTotalRoomPrice = {
              res: this.updatedPrices.initTotalRoomPrice.res,
              nonres: this.updatedPrices.initTotalRoomPrice.nonres,
              rooms: this.roomSummary.totalRoomPrice
            }
          }
          dt.childrenAges.pop()
          const childrenpostData = {
            room_id: room.id,
            adults: dt.adult,
            children: dt.children,
            children_ages: dt.childrenAges,
            babies: dt.infant,
            coupon_code: this.promo,
            room_count: index + 1,
            checkin_date: this.checkinDate,
            checkout_date: this.checkoutDate,
            meal_plan: mealplan,
            totalDiscount: initTotalDiscount,
            subTotal: initSubTotal,
            totalServiceCharge: initTotalServiceCharge,
            totalHotelTax: initTotalHotelTax,
            totalVAT: initTotalVAT,
            totalRoomPrice: initTotalRoomPrice,
            totalGatewayFee: initTotalGatewayFee,
            totalAmountPayable: initTotalAmountPayable
          }
          var adultpostDataJson = JSON.stringify(childrenpostData)
          var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
          var encryptedPostData = this.CryptoJSAesEncrypt(
            passkey,
            adultpostDataJson
          )
          try {
            const url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.removeRoom`
            const formData = new FormData()
            formData.append('pid', this.propertyid)
            formData.append('consumer_key', this.consumerKey)
            formData.append('data', encryptedPostData)
            const response = await this.axios.post(url, formData)
            if (response) {
              let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
              this.errors = false
              this.errorMsg = []
              if (data !== '') {
                data = JSON.parse(data)
                let uniquekey = room.id + '-' + indx + '-' + untkey
                if (data.error === 1) {
                  this.errormsg = data.msg
                  this.multiRoomResult = {}
                  setTimeout(() => {
                    loader.style.display = 'none'
                    loaderCover.style.opacity = 1
                    this.clicked = false
                  }, 1000)
                } else {
                  this.multiRoomResult[uniquekey] = {
                    id: room.id,
                    data: data,
                    room: room,
                    adult: dt.adult,
                    children: dt.children,
                    babies: dt.infant,
                    boards: selectedBoard
                  }
                  // update prices
                  this.roomPrice = data.roomPrice
                  this.totalRoomPrice = data.totalRoomPrice
                  this.subTotal = data.subTotal
                  this.totalGatewayFee = data.totalGatewayFee
                  this.roomDiscount = data.roomDiscount
                  this.totalDiscount = data.totalDiscount
                  this.total = data.totalAmountPayable
                  this.serviceCharge = data.totalServiceCharge
                  this.totalVat = data.totalVAT
                  this.hotelTax = data.totalHotelTax

                  this.roomSummary = {
                    totalDiscount: data.totalDiscount.rooms,
                    subTotal: data.subTotal.rooms,
                    serviceCharge: data.totalServiceCharge.rooms,
                    totalHotelTax: data.totalHotelTax.rooms,
                    totalVAT: data.totalVAT.rooms,
                    totalRoomPrice: data.totalRoomPrice.rooms
                  }

                  // updating value of session
                  this.updatedPrices = {
                    initTotalDiscount: data.totalDiscount,
                    initSubTotal: data.subTotal,
                    initTotalServiceCharge: data.totalServiceCharge,
                    initTotalHotelTax: data.totalHotelTax,
                    initTotalVAT: data.totalVAT,
                    initTotalGatewayFee: data.totalGatewayFee,
                    initTotalAmountPayable: data.totalAmountPayable,
                    initTotalRoomPrice: data.totalRoomPrice
                  }

                  // getting coupons
                  var couponDetail = {}
                  for (const coupon of Object.values(room.discount_coupons)) {
                    couponDetail = {
                      id: coupon.id,
                      code: coupon.code,
                      name: coupon.code,
                      boards: coupon.boards,
                      start_date: coupon.start_date,
                      end_date: coupon.end_date,
                      type: coupon.type
                    }
                  }

                  let totalpayble = 0
                  let dailyAdultRate = 0
                  let totalDailtRate = 0
                  let totalChildrenDailyRate = 0
                  let totalDailyDiscountRate = 0
                  if (this.proofRes === 0) {
                    totalpayble = data.roomPrice.res
                    dailyAdultRate = data.roomPrice.daily.adults.res
                    totalDailtRate = data.roomPrice.daily.res
                    totalChildrenDailyRate = data.roomPrice.daily.children.res
                    totalDailyDiscountRate = data.roomDiscount.daily.res
                  } else {
                    totalpayble = data.roomPrice.nonres
                    dailyAdultRate = data.roomPrice.daily.adults.nonres
                    totalDailtRate = data.roomPrice.daily.nonres
                    totalChildrenDailyRate = data.roomPrice.daily.children.nonres
                    totalDailyDiscountRate = data.roomDiscount.daily.nonres
                  } // formatin
                  // formating room data to be posted
                  this.selectedRooms[uniquekey] = {
                    id: room.id,
                    total_adult: dt.adult,
                    name: room.name,
                    no_rooms: 1,
                    cguest: dt.children,
                    children_ages: this.children_ages,
                    bguest: dt.infant,
                    meal_plan: mealplan,
                    totalprice_book: totalpayble,
                    coupon_details: JSON.stringify(couponDetail),
                    daily_rates: {
                      total: totalDailtRate,
                      adults: dailyAdultRate,
                      children: totalChildrenDailyRate,
                      discount: totalDailyDiscountRate
                    }
                  }
                  // endformating
                  const payload = {
                    subtotal: this.subTotal,
                    servicecharges: this.serviceCharge,
                    totalvat: this.totalVat,
                    hoteltax: this.hotelTax,
                    total: this.total,
                    discount: this.totalDiscount,
                    GatewayFee: this.totalGatewayFee
                  }
                  this.$store.dispatch('updatePrices', payload)
                  this.multi_result = true
                  this.findTotalRoomOccupant()
                  setTimeout(() => {
                    loader.style.display = 'none'
                    loaderCover.style.opacity = 1
                    this.clicked = false
                  }, 1000)
                  if (data.roomPrice.res === 0 || data.roomPrice.nonres === 0) {
                    delete this.multiRoomResult[uniquekey]
                    delete this.selectedRooms[uniquekey]
                  }
                }
              }
            }
          } catch (error) { }
        }
      }
    },
    redirectToMultiroomBookDetail (multiBookResult, selectedroom) {
      let payload = {
        selectedmultiroom: selectedroom,
        result: multiBookResult,
        res: this.proofRes,
        checkindate: this.checkinDate,
        checkoutdate: this.checkoutDate
      }
      this.$store.dispatch('gotoMultiRoomBookDetail', payload)
      const payload2 = {
        room: [],
        board: [],
        res: this.proofRes,
        resident: this.resident
      }
      this.$store.dispatch('gotoBookDetail', payload2)
      this.$router.push({
        path: '/multi-room-book-detail/?pid=' + btoa(this.propertyid)
      })
    },
    async removeAdult (index, room, board, data, indx) {
      var loader = document.getElementById(
        'loading-' + room.id + '-' + data.key
      )
      var loaderCover = document.getElementById(
        'loading-cover-' + room.id + '-' + data.key
      )
      loaderCover.style.opacity = 0.3
      loader.style.display = 'block'
      var inputval = parseInt(
        document.getElementById('adult-' + data.ukey).value,
        10
      )
      inputval = isNaN(inputval) ? 0 : inputval
      if (inputval !== 0) {
        inputval--
        document.getElementById('adult-' + data.ukey).value = inputval
        --data.adult
        this.adultCount = data.adult
        this.children_ages = data.childrenAges
        this.clicked = true
        this.child = data.children
        this.infant = data.infant
        this.adultCount = data.adult
        this.roomId = room.id
        this.totalAdults = this.getTotalAdult(indx, room.id)
        this.totalChildren = this.getTotalChildren(indx, room.id)
        const payloadoccupancy = {
          totalAdult: this.totalAdults,
          totalChildren: this.totalChildren,
          totalBabies: this.totalBabies
        }
        this.$store.commit('updateOccupancy', payloadoccupancy)
        this.mealPlan = board.name
        var selectedBoard = []
        var mealplan = ''
        if (
          board.name.toLowerCase() === 'bed only' ||
          board.name.toLowerCase() === 'bed' || board.name.toLowerCase() === 'self catering'
        ) {
          mealplan = 'BO'
        } else if (board.name.toLowerCase() === 'bed & breakfast') {
          mealplan = 'BB'
        } else if (
          board.name.toLowerCase() === 'half board' ||
          board.name.toLowerCase() === 'halfboard'
        ) {
          mealplan = 'HB'
        } else if (
          board.name.toLowerCase() === 'fullboard' ||
          board.name.toLowerCase() === 'full board'
        ) {
          mealplan = 'FB'
        } else if (board.name.toLowerCase() === 'all inclusive') {
          mealplan = 'AI'
        }
        selectedBoard.push(mealplan)
        // updating prices
        this.roomPrice = board.roomPrice
        this.totalRoomPrice = board.totalRoomPrice
        this.subTotal = board.subTotal
        this.totalGatewayFee = board.totalGatewayFee
        this.roomDiscount = board.roomDiscount
        this.totalDiscount = board.totalDiscount
        this.total = board.totalAmountPayable
        this.serviceCharge = board.totalServiceCharge
        this.totalVat = board.totalVAT
        this.hotelTax = board.totalHotelTax

        // getting initial prices payloads

        var initTotalDiscount = {
          res: this.updatedPrices.initTotalDiscount.res,
          nonres: this.updatedPrices.initTotalDiscount.nonres,
          rooms: this.roomSummary.totalDiscount
        }
        var initSubTotal = {
          res: this.updatedPrices.initSubTotal.res,
          nonres: this.updatedPrices.initSubTotal.nonres,
          rooms: this.roomSummary.subTotal
        }
        var initTotalServiceCharge = {
          res: this.updatedPrices.initTotalServiceCharge.res,
          nonres: this.updatedPrices.initTotalServiceCharge.nonres,
          rooms: this.roomSummary.serviceCharge
        }
        var initTotalHotelTax = {
          res: this.updatedPrices.initTotalHotelTax.res,
          nonres: this.updatedPrices.initTotalHotelTax.nonres,
          rooms: this.roomSummary.totalHotelTax
        }
        var initTotalVAT = {
          res: this.updatedPrices.initTotalVAT.res,
          nonres: this.updatedPrices.initTotalVAT.nonres,
          rooms: this.roomSummary.totalVAT
        }
        var initTotalGatewayFee = this.updatedPrices.initTotalGatewayFee
        var initTotalAmountPayable = this.updatedPrices.initTotalAmountPayable
        var initTotalRoomPrice = {
          res: this.updatedPrices.initTotalRoomPrice.res,
          nonres: this.updatedPrices.initTotalRoomPrice.nonres,
          rooms: this.roomSummary.totalRoomPrice
        }

        const adultpostData = {
          room_id: room.id,
          adults: data.adult,
          children: data.children,
          children_ages: data.childrenAges,
          babies: data.infant,
          room_count: index + 1,
          coupon_code: this.promo,
          checkin_date: this.checkinDate,
          checkout_date: this.checkoutDate,
          meal_plan: mealplan,
          totalDiscount: initTotalDiscount,
          subTotal: initSubTotal,
          totalServiceCharge: initTotalServiceCharge,
          totalHotelTax: initTotalHotelTax,
          totalVAT: initTotalVAT,
          totalGatewayFee: initTotalGatewayFee,
          totalRoomPrice: initTotalRoomPrice,
          totalAmountPayable: initTotalAmountPayable
        }

        var adultpostDataJson = JSON.stringify(adultpostData)
        var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
        var encryptedPostData = this.CryptoJSAesEncrypt(
          passkey,
          adultpostDataJson
        )
        try {
          const url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.removeRoom`
          const formData = new FormData()
          formData.append('pid', this.propertyid)
          formData.append('consumer_key', this.consumerKey)
          formData.append('data', encryptedPostData)
          const response = await this.axios.post(url, formData)
          if (response) {
            let result = this.CryptoJSAesDecrypt(passkey, response.data.er)
            this.errors = false
            this.errorMsg = []
            if (result !== '') {
              result = JSON.parse(result)
              let uniquekey = room.id + '-' + indx + '-' + data.ukey
              if (result.error === 1) {
                delete this.multiRoomResult[uniquekey]
                // this.multiRoomResult = {}
                this.errormsg = result.msg
                setTimeout(() => {
                  loader.style.display = 'none'
                  loaderCover.style.opacity = 1
                  this.clicked = false
                }, 1000)
              } else {
                this.multiRoomResult[uniquekey] = {
                  id: room.id,
                  data: result,
                  room: room,
                  adult: data.adult,
                  children: data.children,
                  babies: data.infant,
                  boards: selectedBoard
                }
                this.roomSummary = {
                  totalDiscount: result.totalDiscount ? result.totalDiscount.rooms : 0,
                  subTotal: result.subTotal ? result.subTotal.rooms : 0,
                  serviceCharge: result.totalServiceCharge ? result.totalServiceCharge.rooms : 0,
                  totalHotelTax: result.totalHotelTax ? result.totalHotelTax.rooms : 0,
                  totalVAT: result.totalVAT ? result.totalVAT.rooms : 0,
                  totalRoomPrice: result.totalRoomPrice ? result.totalRoomPrice.rooms : 0
                }
                // updating prices
                this.roomPrice = result.roomPrice ? result.roomPrice : 0
                this.totalRoomPrice = result.totalRoomPrice ? result.totalRoomPrice : 0
                this.subTotal = result.subTotal ? result.subTotal : 0
                this.totalGatewayFee = result.totalGatewayFee ? result.totalGatewayFee : 0
                this.roomDiscount = result.roomDiscount ? result.roomDiscount : 0
                this.totalDiscount = result.totalDiscount ? result.totalDiscount : 0
                this.total = result.totalAmountPayable ? result.totalAmountPayable : 0
                this.serviceCharge = result.totalServiceCharge ? result.totalServiceCharge : 0
                this.totalVat = result.totalVAT ? result.totalVAT : 0
                this.hotelTax = result.totalHotelTax ? result.totalHotelTax : 0

                //  updating prices
                this.updatedPrices = {
                  initTotalDiscount: result.totalDiscount,
                  initSubTotal: result.subTotal,
                  initTotalServiceCharge: result.totalServiceCharge,
                  initTotalHotelTax: result.totalHotelTax,
                  initTotalVAT: result.totalVAT,
                  initTotalGatewayFee: result.totalGatewayFee,
                  initTotalAmountPayable: result.totalAmountPayable,
                  initTotalRoomPrice: result.totalRoomPrice
                }

                // getting coupons
                var couponDetail = {}
                for (const coupon of Object.values(room.discount_coupons)) {
                  couponDetail = {
                    id: coupon.id,
                    code: coupon.code,
                    name: coupon.code,
                    boards: coupon.boards,
                    start_date: coupon.start_date,
                    end_date: coupon.end_date,
                    type: coupon.type
                  }
                }

                let totalpayble = 0
                let dailyAdultRate = 0
                let totalDailtRate = 0
                let totalChildrenDailyRate = 0
                let totalDailyDiscountRate = 0
                if (this.proofRes === 0) {
                  totalpayble = result.roomPrice.res ? result.roomPrice.res : 0
                  dailyAdultRate = result.roomPrice.daily.adults.res ? result.roomPrice.daily.adults.res : 0
                  totalDailtRate = result.roomPrice.daily.res ? result.roomPrice.daily.res : 0
                  totalChildrenDailyRate = result.roomPrice.daily.children.res ? result.roomPrice.daily.children.res : 0
                  totalDailyDiscountRate = result.roomDiscount.daily.res ? result.roomDiscount.daily.res : 0
                } else {
                  totalpayble = result.roomPrice.nonres ? result.roomPrice.nonres : 0
                  dailyAdultRate = result.roomPrice.daily.adults.nonres ? result.roomPrice.daily.adults.nonres : 0
                  totalDailtRate = result.roomPrice.daily.nonres ? result.roomPrice.daily.nonres : 0
                  totalChildrenDailyRate = result.roomPrice.daily.children.nonres ? result.roomPrice.daily.children.nonres : 0
                  totalDailyDiscountRate = result.roomDiscount.daily.nonres ? result.roomDiscount.daily.nonres : 0
                }
                // formating room data to be posted
                this.selectedRooms[uniquekey] = {
                  id: room.id,
                  total_adult: data.adult,
                  name: room.name,
                  no_rooms: 1,
                  cguest: data.children,
                  children_ages: this.children_ages,
                  bguest: data.infant,
                  meal_plan: mealplan,
                  totalprice_book: totalpayble,
                  coupon_details: JSON.stringify(couponDetail),
                  daily_rates: {
                    total: totalDailtRate,
                    adults: dailyAdultRate,
                    children: totalChildrenDailyRate,
                    discount: totalDailyDiscountRate
                  }
                }
                // endformating
                const payload = {
                  subtotal: this.subTotal,
                  servicecharges: this.serviceCharge,
                  totalvat: this.totalVat,
                  hoteltax: this.hotelTax,
                  total: this.total,
                  discount: this.totalDiscount,
                  GatewayFee: this.totalGatewayFee
                }
                this.$store.dispatch('updatePrices', payload)
                this.findTotalRoomOccupant()
                this.multi_result = true
                setTimeout(() => {
                  loader.style.display = 'none'
                  loaderCover.style.opacity = 1
                  this.clicked = false
                }, 1000)
                if (result.roomPrice.res === 0 || result.roomPrice.nonres === 0) {
                  delete this.multiRoomResult[uniquekey]
                  delete this.selectedRooms[uniquekey]
                }
                if (Object.keys(this.multiRoomResult).length === 0) {
                  this.updatedPrices = {}
                }
              }
            }
          }
        } catch (error) { }
      }
    },
    addInfant (index, room, board, dt, indx) {
      if (
        this.bookings.data[this.propertyid].age_group_details.babies_allowed !==
        0
      ) {
        this.child = dt.children
        this.infant = dt.infant
        this.adultCount = dt.adult
        this.roomId = room.id
        this.children_ages = dt.childrenAges
        this.mealPlan = board.name
        // const roomGuestTotal = this.child + this.infant + this.adultCount
        ++dt.infant
        this.infant = dt.infant
        // const totalGuest = this.getTotalGuest(indx, room.id)
        this.totalAdults = this.getTotalAdult(indx, room.id)
        this.totalChildren = this.getTotalChildren(indx, room.id)
        const payloadoccupancy = {
          totalAdult: this.totalAdults,
          totalChildren: this.totalChildren,
          totalBabies: this.totalBabies
        }
        this.$store.commit('updateOccupancy', payloadoccupancy)
      } else {
        this.$alert('Babies are not allowed at this property.', '', 'warning')
      }
    },
    removeInfant (index, room, board, data, indx) {
      if (data.infant !== 0) {
        --data.infant
        this.infant = data.infant
        this.adultCount = data.adult
        this.children_ages = data.childrenAges
        // const noOfRooms = index + 1
        this.child = data.children
        this.infant = data.infant
        this.adultCount = data.adult
        this.roomId = room.id
        // const totalGuest = this.getTotalGuest(indx, room.id)
        this.totalAdults = this.getTotalAdult(indx, room.id)
        this.totalChildren = this.getTotalChildren(indx, room.id)
        const payloadoccupancy = {
          totalAdult: this.totalAdults,
          totalChildren: this.totalChildren,
          totalBabies: this.totalBabies
        }
        this.$store.commit('updateOccupancy', payloadoccupancy)
      }
    },
    async checkAvailabilty (type) {
      const configUrl = process.env.CONFIG_URL['live_url']
      const key = process.env.PMS_KEY['key']
      this.checkinDate = this.chckinDate
      this.checkoutDate = this.chckoutDate
      this.babies = this.defaultbabiesNo
      this.children = this.defaultChildrenNo
      this.adult = this.defaultAdultNo
      // test id if no root id is found
      var hash = document.location.hash
      var urlparameters = hash.split('?')[1]
      var propid = urlparameters.split('&')[0]
      // var reference =
      var encodedpid = propid.split('=')[1]
      var reconstructedpid1 = encodedpid.split('%3D')
      var reconstructedpid = reconstructedpid1.join('=')
      if (this.destination !== '') {
        this.propertyid = this.destination
      } else {
        this.propertyid = atob(reconstructedpid)
      }
      if (
        parseInt(this.room) === 1 &&
        parseInt(this.adult) === 0 &&
        parseInt(this.children) === 0
      ) {
        this.room = 1
        this.adult = 1
        this.children = 0
      } else {
        this.adult = parseInt(this.adult)
        this.children = parseInt(this.children)
      }
      this.guest =
        parseInt(this.adult) + parseInt(this.babies) + parseInt(this.children)
      if (this.roomType !== '') {
        this.$router.push({
          path: '/room-details?rid=' +
            this.roomType +
            '&pid=' +
            btoa(this.propertyid)
        })
      }
      if (parseInt(this.room) === 1) {
        this.$router.push({
          path: '/?pid=' + btoa(this.propertyid)
        })
      } else {
        const config = {
          headers: { 'Accept': 'application/json' }
        }
        const payload = {
          'property_id': this.propertyid,
          'api': this.type
        }
        const configRes = await this.$http.post(configUrl, payload, config)
        if (configRes.status === 200) {
          let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
          configData = JSON.parse(configData)
          const passkey = configData[0].val_ptoken // process.env.SECRET_KEY[this.propertyid].key
          this.consumerKey = configData[0].val_reserveport_secret_key // process.env.CONSUMER_KEY[this.propertyid].key
          const details = JSON.parse(configData[0].add_details)
          this.secretKey = passkey
          this.postUrl = details.url
          this.isSearching = true
          const postData = {
            checkin_date: this.checkinDate,
            checkout_date: this.checkoutDate,
            client_email: this.email,
            room: this.room,
            babies: this.babies,
            children: this.children,
            children_ages: this.childAges,
            adults: this.adult,
            coupon_code: this.promo,
            isNonRefundable: this.nonRefundable
          }
          var postDataJson = JSON.stringify(postData)
          var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
          try {
            const posturl = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.searchAvailability`
            const formData = new FormData()
            formData.append('pid', this.propertyid)
            formData.append('consumer_key', this.consumerKey)
            formData.append('data', encryptedData)
            const response = await this.axios.post(posturl, formData)
            if (response) {
              let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
              this.errors = false
              this.errorMsg = []
              if (data !== '') {
                data = JSON.parse(data)
                this.guestOccupancy = this.guest
                this.period = this.calculateStayNights(this.checkinDate, this.checkoutDate)
                this.periodText = this.getPeriodText(this.period)
                this.bookings = data
                this.bookingData = this.bookings.data[this.propertyid]
                this.roomLabel = this.bookings.data[this.propertyid].room_label
                this.guestFormSettings =
                  this.bookings.data[this.propertyid].guest_form_settings
                this.ageGroupsDetails =
                  this.bookings.data[this.propertyid].age_group_details
                if (this.bookings.data[this.propertyid].rooms.length === 0) {
                  this.errors = true
                  this.errorMsg.push('No available rates')
                }
                // checking existing currency
                const payload = {
                  bookingData: data,
                  checkinDate: this.checkinDate,
                  checkOutDate: this.checkoutDate,
                  stay_period: this.period
                }
                this.$store.dispatch('getBookingData', payload)
                this.multiRoomResult = {}
                this.divs = []
                this.selectedRooms = {}
                this.updatedPrices = {}
                for (const result of Object.values(
                  this.bookings.data[this.propertyid].rooms
                )) {
                  for (const boardkey of Object.keys(result.boards)) {
                    var inputValue = document.getElementById(
                      'unit-selection-' + result.id + '-' + boardkey
                    )
                    if (inputValue != null) {
                      document.getElementById(
                        'unit-selection-' + result.id + '-' + boardkey
                      ).value = 0
                    }
                  }
                }
                this.checkInDate = this.$store.state.checkinDate
                this.checkOutDate = this.$store.state.checkoutDate
                this.period = this.$store.state.period
                this.isSearching = false
                this.getOffers(this.propertyid)
                if (this.multipropertyStatus === true) {
                  this.gettingMultiProperties()
                }
              } else {
                this.errors = true
                this.errorMsg.push('Failed to decrypte data')
              }
            }
          } catch (error) { }
        } else {
          this.propertyerror = true
        }
      }
    },
    async searchAndCloseMobileModal () {
      await this.checkAvailabilty('s')
      const closeBtn = document.getElementById('btn_close')
      if (closeBtn) {
        closeBtn.click()
      }
    },
    getAvailableRoom (availability) {
      if (availability > 10) {
        var available = 10
      } else {
        available = availability
      }
      return parseInt(available)
    },
    // function for offers
    getCheckinDate (date) {
      let today = moment(date).format('YYYY-MM-DD')
      if (today === 'Invalid date') {
        today = moment().format('YYYY-MM-DD')
      } else {
        if (moment(date).isBefore(today) === true) {
          today = moment().format('YYYY-MM-DD')
        }
      }
      return today
    },
    getCheckoutDate (date, minnights) {
      let today = moment(date).format('YYYY-MM-DD')
      if (today === 'Invalid date') {
        today = moment().format('YYYY-MM-DD')
      } else {
        if (moment(date).isBefore(today) === true) {
          today = moment().format('YYYY-MM-DD')
        }
      }
      var tommorow = moment(today).add(minnights, 'days').format('YYYY-MM-DD')
      return tommorow
    },
    nextPage () {
      if (this.currentPage === this.pageCount) {
        this.currentPage = 1
      } else {
        this.currentPage++
      }
    },
    prevPage () {
      if (this.currentPage === 1) {
        this.currentPage = this.pageCount
      } else {
        this.currentPage--
      }
    },
    submitOffer () {
      document.getElementById('vueofferForm').submit()
    }
    // end
  },
  mixins: [reusableData],
  computed: {
    pageCount () {
      let l = this.allOffers.length
      let s = this.size
      return Math.ceil(l / s)
    },
    allOffers () {
      let generatedOffers = []
      var innerOffers = Object.values(this.offers)

      innerOffers.forEach((array) => {
        array.forEach((it) => {
          generatedOffers.push(it)
        })
      })
      return generatedOffers
    },
    paginatedData () {
      return this.allOffers.slice(
        (this.currentPage - 1) * this.size,
        this.currentPage * this.size
      )
    },
    totalPages () {
      return Math.ceil(this.allOffers.length / this.size)
    },
    ...mapState({
      checkinDate: state => state.checkinDate,
      checkoutDate: state => state.checkoutDate,
    }),
    mobileCheckinLabel () {
      return this.checkinDate ? moment(this.checkinDate).format('ddd, D MMM') : 'Select date'
    },
    mobileCheckoutLabel () {
      return this.checkoutDate ? moment(this.checkoutDate).format('ddd, D MMM') : 'Select date'
    }
  }
}
</script>

<style>
@import '../assets/styles/main.css';
</style>



// WEBPACK FOOTER //
// src/components/multiBook.vue